<template>
  <v-container>
    <v-card class="pa-16">
      <v-card-title>
        <v-row>
          <v-col cols="6" md="6" justify="center">
            <h3>{{ titleheader }}</h3>
          </v-col>
          <v-col cols="6" md="6">
            <v-row>
              <v-col class="text-right" cols="12" md="12">
                <v-row justify="end">
                  <v-col class="text-right" cols="12" md="4">
                    <h5>No. {{ showinv_id }}</h5>
                  </v-col>
                </v-row>
                <v-row justify="end">
                  <v-col class="text-right" cols="12" md="4">
                    <h5>
                      <v-menu v-model="menu2" :close-on-content-click="false" :nudge-right="40"
                        transition="scale-transition" offset-y>
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field :disabled="datainv_disable" class="mt-n7" v-model="computedDateFormatted"
                            label="Date." append-icon="mdi-calendar" readonly dense outlined v-bind="attrs"
                            v-on="on"></v-text-field>
                        </template>

                        <v-date-picker v-model="date" @input="menu2 = false"></v-date-picker>
                      </v-menu>
                    </h5>
                  </v-col>
                </v-row>
                <v-row justify="end">
                  <v-col class="text-right" cols="12" md="4">
                    <v-text-field :disabled="datainv_disable" class="mt-n10" label="Period_cover" v-model="period_cover"
                      outlined dense></v-text-field>
                  </v-col>
                </v-row>

                <!-- <v-row justify="end">
                    <v-btn
                      depressed
                      class="mx-2"
                      color="blue darken-1"
                      outlined
                      @click="getPrintOutData()"
                    >
                      print Invoice
                    </v-btn>
                  </v-row> -->
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-title>

      <v-row justify="start">
        <v-col class="text-right" cols="12" md="4">
          <v-text-field disabled class="" label="Creator" v-model="getaccount_userid" outlined dense></v-text-field>
        </v-col>
        <v-col class="text-right" cols="12" md="4">
          <v-autocomplete :disabled="disabled_dep" class="" :items="department_list" label="For Department"
            item-text="department_name" item-value="id" v-model="add_h.dept" outlined dense></v-autocomplete>
        </v-col>
      </v-row>

      <br />
      <div id="tabs" class="containertab">
        <div class="tabs">
          <a v-on:click="activetab = 1" v-bind:class="[activetab === 1 ? 'active' : '']">Service</a>
          <a class="ml-1" v-on:click="activetab = 2" v-bind:class="[activetab === 2 ? 'active' : '']">Timesheet</a>
          <a class="ml-1" v-on:click="activetab = 3" v-bind:class="[activetab === 3 ? 'active' : '']">Advance</a>
          <a class="ml-1" v-on:click="activetab = 4" v-bind:class="[activetab === 4 ? 'active' : '']">Miscellaneous
            disbursements</a>
          <!-- <a
            class="ml-1"
            v-on:click="activetab = 5"
            v-bind:class="[activetab === 5 ? 'active' : '']"
            >Additional Note</a
          > -->
        </div>

        <div class="content">
          <div v-if="activetab === 1 && callsoopentab == true" class="tabcontent">
            <InvoiceFreeTextSalseorderTab :cus_code="cus_code" :menurequest="menurequest" :vat_cus="vat_cus"
              :payment_term_cus="payment_term_cus" :po_no_cus="po_no_cus" :attention_cus="attention_cus"
              :contact_position_cus="contact_position_cus" :vat_type_cus="vat_type_cus" :desserts="desserts"
              :datainv_disable="datainv_disable" :so_id="this.$route.params.id" :datainv_h="getdatefrom_inv_h"
              :datainv_so="getdatefrom_inv_so" @inv_sotab_isheader="getdatafromSOisheader"
              @inv_sotab_vat="getdatafromSOvat" @inv_sotab_customer="getdatafromSOCustomer"
              @inv_sotab_noheader="getdatafromSOcomponent" @inv_sotab_tabledesserts="getdatafromSOtable"
              @inv_sotab_vatcus="getdatavatcus" @inv_sotab_paymentcus="getdatapaymentcus"
              @inv_sotab_ponocus="getdataPonoCus" @inv_sotab_attentioncus="getdataAttentionCus"
              @inv_sotab_contact_positioncus="getdatacontact_positionCus" @inv_sotab_vat_type="getdatavat_type">
            </InvoiceFreeTextSalseorderTab>
          </div>
          <div v-if="activetab === 2" class="tabcontent">
            <InvoiceFreetextTimesheetTab :getdataByCusStatus="getdataByCusStatus" :cusid_freetext_ts="cusid_freetext_ts"
              :disableinstatus="disableinstatus" :ts_status_oper="ts_status_oper" :ts_idTab="ts_idTab"
              :selected_showE="selected_showE" :oper_sel="oper_sel" :cus_invts="this.inv_ts_list"
              @getdatafromTStotal="getdatafromTStotal" @getTsIdTab="getTsId" @getSelected_showETab="getSelected_showE"
              @getOper_selTab="getOper_sel" @getInvTsListTab="getInvTsList"></InvoiceFreetextTimesheetTab>
          </div>
          <div v-if="activetab === 3" class="tabcontent">
            <InvoiceFreetextAdvanceTab :cusid_freetext_ts="cusid_freetext_ts" :tsTAB_IdforCus="this.$route.params.id"
              :getdataByCusStatus="getdataByCusStatus" :disableinstatus="disableinstatus"
              :ts_status_oper="ts_status_oper" :ad_idTab="ad_idTab" :selected_showAv="selected_showAv"
              :oper_sel_Av="oper_sel_Av" @getSelected_showAvTab="getSelected_showEAv" @getOper_sel_avTab="getOper_selAv"
              @getdatafromAdtotal="getdatafromAdtotal" @getAdIdTab="getAdId" @getAdInvioceIdTab="getAdInvioceId">
            </InvoiceFreetextAdvanceTab>
          </div>
          <div v-if="activetab === 4" class="tabcontent">
            <InvoiceMiscellaneousTab :datainv_disable="datainv_disable" :datainv_mis="datainv_mis"
              @inv_mistab_data="getdatafromMis"></InvoiceMiscellaneousTab>
          </div>
          <div v-if="activetab === 5" class="tabcontent">
            <!-- <AdditionalNoteTab
              :datainv_disable="datainv_disable"
              :datainv_additional_top="add_h.additional_top"
              :datainv_additional_bottom="add_h.additional_bottom"
              @inv_additionaltab_data="getdatafromadditional"
            ></AdditionalNoteTab> -->
          </div>
        </div>
      </div>

      <v-row justify="center" align="center">
        <v-col cols="12" md="12">
          <v-row>
            <div align="center" class="width16">
              <h5>Service Total</h5>
              <v-text-field reverse v-model="so_total" outlined dense background-color="#F5F5F5"
                disabled></v-text-field>
            </div>
            <div justify="center" align="center" class="widthplus font-weight-black mt-7">
              <span> + </span>
            </div>

            <div align="center" class="width16">
              <h5>Timesheet Total</h5>
              <v-text-field reverse v-model="ts_total" outlined dense background-color="#F5F5F5"
                disabled></v-text-field>
            </div>
            <div justify="center" align="center" class="widthplus font-weight-black mt-7">
              <span> + </span>
            </div>

            <div align="center" class="width16">
              <h5>Advance Total</h5>
              <v-text-field reverse v-model="ad_total" outlined dense background-color="#F5F5F5"
                disabled></v-text-field>
            </div>
            <div justify="center" align="center" class="widthplus font-weight-black mt-7">
              <span> + </span>
            </div>

            <div align="center" class="width16">
              <h5>Miscellaneous Total</h5>
              <v-text-field reverse v-model="mis_total" outlined dense background-color="#F5F5F5"
                disabled></v-text-field>
            </div>
            <div justify="center" align="center" class="widthsub font-weight-black mt-7">
              <span> = </span>
            </div>

            <div align="center" class="widthsubtotal">
              <h5>Sub Total</h5>
              <v-text-field reverse v-model="inv_subtotal" outlined dense background-color="#F5F5F5"
                disabled></v-text-field>
            </div>
          </v-row>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="6">
          <v-row>
            <v-col cols="12" md="12">
              Upload File
              <span class="red--text">(Support .pdf files only) </span>
            </v-col>
          </v-row>
          <v-row class="mt-0">
            <v-col cols="12" md="12">
              <input type="file" accept="application/pdf" @change="previewMultiImage" class="inputsize" ref="filefile"
                style="display: none" multiple="multiple" />
              <v-btn :style="{
                backgroundColor: '#254E58',
                color: 'white',
              }" class="widthbtnimagefile" @click="$refs.filefile.click()" elevation="7">
                <v-icon left dark color="white"> mdi-cloud-upload </v-icon>
                Upload file
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="12" align="start">
              <v-row>
                <v-col cols="12" md="12" align="start">
                  <h5>
                    <v-row>
                      <v-col cols="12" md="3" align="start">
                        Files Name:
                      </v-col>
                      <v-col cols="12" md="8" align="start">
                        <span v-for="(item, index) in this.filename" :key="index">
                          <a @click="popuppreviewfile(index)" :style="{
                            color: '#43a047',
                          }">
                            {{ item }}</a>

                          <v-btn :style="{
                            backgroundColor: '#FFEBEE',
                            color: '#F44336',
                          }" small icon @click="popupdeletefile(index)">
                            <v-icon small>mdi-close</v-icon>
                          </v-btn>
                          <br />
                        </span>
                      </v-col>
                    </v-row>
                  </h5>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" md="6">
          <v-row>
            <div align="center" class="widthgrandnull"></div>
            <div justify="center" align="right" class="widthglessword font-weight-black mt-5">
              <p>Less Withholding Tax</p>
            </div>
            <div class="widthspace"></div>

            <div align="center" class="widthlesspersen">
              <v-text-field :disabled="datainv_disable" reverse @keyup="calwth_rate" v-model="wth_rate" outlined
                dense></v-text-field>
            </div>
            <div justify="center" align="center" class="widthtextpersen font-weight-black mt-4">
              <h5 class="body-1 font-weight-black">% =</h5>
            </div>
            <div align="center" class="widthlesstotal">
              <v-text-field reverse v-model="wth_ratetotal" outlined background-color="#F5F5F5" disabled
                dense></v-text-field>
            </div>
          </v-row>

          <v-row>
            <div align="center" class="widthgrandnull"></div>
            <div justify="center" align="right" class="widthglessword font-weight-black mt-4">
              <p>Vat</p>
            </div>
            <div class="widthspace"></div>

            <div align="center" class="widthlesspersen">
              <v-text-field :disabled="datainv_disable" reverse @keyup="caltax_rate" v-model="tax_rate" outlined
                dense></v-text-field>
            </div>
            <div justify="center" align="center" class="widthtextpersen font-weight-black mt-4">
              <h5 class="body-1 font-weight-black">% =</h5>
            </div>
            <div align="center" class="widthlesstotal">
              <v-text-field reverse v-model="tax_ratetotal" outlined background-color="#F5F5F5" disabled
                dense></v-text-field>
            </div>
          </v-row>

          <v-row>
            <div align="center" class="widthgrandnull"></div>
            <div justify="center" align="right" class="widthglessword font-weight-black mt-4">
              <p>Grand Total</p>
            </div>
            <div class="widthspace"></div>

            <div align="center" class="widthsubtotalG">
              <v-text-field reverse v-model="amount_total" outlined background-color="#F5F5F5" disabled
                dense></v-text-field>
            </div>
          </v-row>
        </v-col>
      </v-row>

      <v-row class="mt-5">
        <v-col align="center" cols="12" md="12">
          <v-btn :disabled="datainv_disable" class="mr-5 buttonblue btn-width" color="#689ADE"
            @click="saveinvDraftandSubmit('Draft')">
            Save Draft
          </v-btn>
          <v-btn :disabled="datainv_disable" depressed class="mr-5 buttonblue btn-width"
            @click="saveinvDraftandSubmit('Submit')">
            Submit
          </v-btn>
          <v-btn :disabled="datainv_disable" depressed class="buttonred btn-width" @click="dialogDeleteForm = true">
            Delete
          </v-btn>
          <!-- <v-btn depressed>
                  Cancel Request
                </v-btn> -->
        </v-col>
      </v-row>
      <template>
        <!-- 
              v-for="index in datashowAll.length"
              v-if="datashowAll.length >= 0 || pageAll >= 0" -->
        <!--   :style="showprint" -->
        <div v-if="datashowAll.length >= 0 || pageAll >= 0" id="mydivhtmltobase" :style="showprint">
          <page size="A4" class="aligncenter" v-for="index in datashowAll.length">
            <div class="aligncenter">
              <!-- <div class="rowprpo ">
                      <div class="col-md-6report"></div>
                      <div class="col-md-6report">
                        <p class="alignright  colprpo mr30prpo mt30">
                          Page : {{ index }}
                        </p>
                      </div>
                    </div> -->

              <div class="rowprpo mr30prpo mt30">
                <div class="col-md-8report"></div>
                <div class="col-md-4report">
                  <h5 class="alignright colprpo">
                    No : {{ print_header.inv_id }}
                  </h5>
                </div>
              </div>
              <div class="rowprpo aligncenter">
                <div class="col-md-12report mt-30prpo">
                  <h3>
                    {{ print_header.com_title }}
                  </h3>
                </div>
              </div>
              <div class="rowprpo aligncenter">
                <div class="col-md-12report">
                  <h3>
                    {{ print_header.com_eng_1 }}
                  </h3>
                </div>
              </div>
              <div class="rowprpo aligncenter fontsize10">
                <div class="col-md-12report">
                  <h3>
                    {{ print_header.com_eng_2 }}
                  </h3>
                </div>
              </div>
              <div class="rowprpo aligncenter col-md-12report fontsize14">
                <div class="col-md-12report">
                  <h4>
                    {{ print_header.com_thai }}
                  </h4>
                </div>
              </div>
              <div class="rowprpo aligncenter col-md-12report fontsize10">
                <div class="col-md-12report">
                  <h4>
                    {{ print_header.com_add_name }}
                  </h4>
                </div>
              </div>
              <div class="rowprpo aligncenter col-md-12report fontsize10">
                <div class="col-md-12report">
                  <h4>
                    {{ print_header.com_add_no }}
                  </h4>
                </div>
              </div>
              <div class="rowprpo aligncenter col-md-12report fontsize10">
                <div class="col-md-12report">
                  <h4>
                    {{ print_header.com_add_city }}
                  </h4>
                </div>
              </div>
              <div class="rowprpo aligncenter col-md-12report fontsize10">
                <div class="col-md-12report">
                  <h4>
                    {{ print_header.com_add_country }}
                  </h4>
                </div>
              </div>
              <div class="rowprpo aligncenter col-md-12report fontsize10">
                <div class="col-md-12report">
                  <h4>
                    {{ print_header.com_add_tel }}
                  </h4>
                </div>
              </div>
              <div class="rowprpo aligncenter col-md-12report fontsize10">
                <div class="col-md-12report">
                  <h4>
                    {{ print_header.com_add_fax }}
                  </h4>
                </div>
              </div>
              <div class="rowprpo aligncenter col-md-12report fontsize10">
                <div class="col-md-12report">
                  <h4>
                    {{ print_header.com_add_email }}
                  </h4>
                </div>
              </div>
              <div class="rowprpo aligncenter col-md-12report fontsize10">
                <div class="col-md-12report">
                  <h5>
                    {{
                      print_header.com_add_tax_id
                        ? print_header.com_add_tax_id
                        : "-"
                    }}
                  </h5>
                </div>
              </div>
              <div class="rowprpo ml30prpo mr30prpo aligncenter col-md-12report fontsize13">
                <v-divider class="borderwidththin"></v-divider>
              </div>
              <div class="rowprpo ml30prpo mr30prpo aligncenter col-md-12report fontsize13">
                <div class="col-md-1report textalignleft">To/ถึง :</div>
                <div class="col-md-6report textalignleft fixonerow">
                  {{
                    print_header.customer_name
                      ? print_header.customer_name
                      : "-"
                  }}
                </div>
                <div class="col-md-3report textalignright fontsize13">
                  Date/วันที่ :
                </div>
                <div class="col-md-2report textalignleft fixonerow">
                  {{
                    print_header.invoice_date ? print_header.invoice_date : "-"
                  }}
                </div>
              </div>
              <div class="rowprpo ml30prpo mr30prpo aligncenter col-md-12report fontsize13 mt-5prpo">
                <div class="col-md-1report">
                  <h5></h5>
                </div>
                <div class="col-md-5report textalignleft fixthreerow">
                  {{ print_header.addressall ? print_header.addressall : "-" }}
                </div>
                <div class="col-md-1report"></div>
                <div class="col-md-3report textalignright">
                  Period Covered / รอบระยะเวลา :
                </div>
                <div class="col-md-2report textalignleft fixonerow">
                  {{
                    print_header.period_cover ? print_header.period_cover : "-"
                  }}
                </div>
              </div>

              <!-- <div
                    class="rowprpo ml30prpo mr30prpo  aligncenter col-md-12report fontsize13"
                  >
                    <div class="col-md-2report textalignleft">
                      Attention :
                    </div>
                    <div
                      class="col-md-6report textalignleft  ml-40prpo fixonerow"
                    >
                      {{
                        print_header.customer_contact_name
                          ? print_header.customer_contact_name
                          : "-"
                      }}
                    </div>
                    <div class="col-md-2report">
                      <h5></h5>
                    </div>
                    <div class="col-md-2report textalignleft">
                      <h5></h5>
                    </div>
                  </div> -->

              <!-- <div
                class="rowprpo ml30prpo mr30prpo  aligncenter col-md-12report fontsize13 mt-5prpo"
              >
                <div class="col-md-1report textalignleft"></div>
                <div class="col-md-6report textalignleft fixonerow">
                  {{
                    print_header.province_invoice
                      ? print_header.province_invoice
                      : "-"
                  }}
                  ,
                  {{
                    print_header.zipcode_invoice
                      ? print_header.zipcode_invoice
                      : "-"
                  }}
                </div>
                <div class="col-md-2report">
                  <h5></h5>
                </div>
                <div class="col-md-2report textalignleft">
                  <h5></h5>
                </div>
              </div> 
              <div
                class="rowprpo ml30prpo mr30prpo  aligncenter col-md-12report fontsize13 mt-5prpo"
              >
                <div class="col-md-1report textalignleft"></div>
                <div class="col-md-6report textalignleft fixonerow">
                  {{
                    print_header.country_invoice
                      ? print_header.country_invoice
                      : "-"
                  }}
                </div>
                <div class="col-md-2report">
                  <h5></h5>
                </div>
                <div class="col-md-2report textalignleft">
                  <h5></h5>
                </div>
              </div>
              -->

              <div class="rowprpo ml30prpo mr30prpo aligncenter col-md-12report fontsize13 mt-5prpo">
                <div class="col-md-1report textalignleft">TAX ID :</div>
                <div class="col-md-6report textalignleft fixonerow">
                  {{
                    print_header.customer_taxid
                      ? print_header.customer_taxid
                      : "-"
                  }}
                </div>
                <div class="col-md-2report">
                  <h5></h5>
                </div>
                <div class="col-md-3report textalignleft">
                  <h5></h5>
                </div>
              </div>
              <div class="rowprpo ml30prpo mr30prpo aligncenter col-md-12report fontsize13">
                <v-divider class="borderwidththin"></v-divider>
              </div>
            </div>

            <div class="rowprpo caption ml30prpo mr30prpo" style="margin-top: 10px">
              <table class="captionhtable">
                <tr>
                  <th scope="colgroup"
                    class="prbordertop2pxhtable prborderbottom2pxhtable width40 thborder-top thborder-left fontsize13 captionhtable">
                    <span class="aligncenter">Description / รายการ </span>
                  </th>
                  <th scope="colgroup"
                    class="prbordertop2pxhtable prborderbottom2pxhtable width10 thborder-top thborder-left thborder-right fontsize13 captionhtable">
                    <span class="aligncenter">Amount / จำนวนเงิน </span>
                  </th>
                </tr>
              </table>

              <table class="captionhtable" style="height: 481px">
                <tr v-for="(data, i) in datashowAll[index - 1]" style="height: 20px">
                  <td style="position: relative" scope="colgroup"
                    class="textalignleft width80 caption prborderbottomsumpo tdborder-left fontsize13 paddingleftintable paddingrightintable">
                    <span v-if="
                      haveSO == false &&
                      i == 0 &&
                      datashowAlltimesheet.length > 0
                    " class="fixtworow fontsize13 textalignleft titledatadetailintable">
                      <br />
                      Professional fee</span>
                    <span class="fixtworow fontsize13" v-if="data.first_item == 1">
                      <!-- <span
                        class="titledatadetailintable"
                        v-if="data.report_type == 'SO'"
                        >Service</span> -->
                      <span class="titledatadetailintable" v-if="data.report_type == 'ADMIS'"><br />Miscellaneous</span>
                      <!-- <span
                        class="titledatadetailintable"
                        v-else-if="data.report_type == 'MIS'"
                        >Miscellaneous</span
                      > -->
                    </span>

                    <span class="textalignleft"> {{ data.report_desc }} </span>
                    <span v-if="
                      data.solastdata == 'SOlastindex' &&
                      haveSO == true &&
                      datashowAlltimesheet.length > 0
                    " class="fixtworow fontsize13 textalignleft titledatadetailintable">
                      <br />
                      Professional fee</span>
                  </td>
                  <td style="position: relative"
                    class="textalignleft width20 caption prborderbottomsumpo tdborder-left tdborder-right fontsize13">
                    <span class="width100 textalignright paddingrightintable"
                      style="vertical-align: top; position: absolute; top: 0px">
                      <span class="fixtworow fontsize13" v-if="
                        haveSO == false &&
                        i == 0 &&
                        datashowAlltimesheet.length > 0
                      ">
                        <br />
                        <span class="textalignright alignright">
                          {{
                            print_header.ts_total.toLocaleString("en-US", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })
                          }}
                        </span>
                      </span>
                      <span class="fixtworow fontsize13" v-if="data.first_item == 1"><br /><br />
                      </span>
                      <span v-if="data.report_amount">
                        {{
                          data.report_amount.toLocaleString("en-US", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })
                        }}
                      </span>

                      <span class="fixtworow fontsize13" v-if="
                        data.solastdata == 'SOlastindex' &&
                        haveSO == true &&
                        datashowAlltimesheet.length > 0
                      ">
                        <br />
                        <span class="textalignright alignright">
                          {{
                            print_header.ts_total.toLocaleString("en-US", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })
                          }}
                        </span>
                      </span>
                    </span>
                  </td>
                </tr>
                <tr>
                  <td scope="colgroup"
                    class="textalignleft width20 caption prborderbottomsumpo tdborder-left tdborder-bottom"></td>
                  <td scope="colgroup"
                    class="textalignleft width20 caption prborderbottomsumpo tdborder-left tdborder-right tdborder-bottom">
                  </td>
                </tr>
              </table>
            </div>
            <div class="footerprpo">
              <div class="rowprpo caption ml30prpo mr30prpo">
                <table class="captionhtable" v-if="index == datashowAll.length">
                  <tr>
                    <td scope="colgroup"
                      class="textalignleft caption prborderbottomsumpo tdborder-left width80 tdborder-bottom paddingleftintable">
                      <h4 class="textalignleft">
                        <span> Sub Total / รวมเป็นเงิน</span>
                      </h4>
                    </td>
                    <td scope="colgroup"
                      class="textalignleft caption prborderbottomsumpo tdborder-left width20 tdborder-right tdborder-bottom paddingrightintable">
                      <span class="textalignright">
                        <h4>
                          {{
                            print_header.sub_total
                              ? print_header.sub_total.toLocaleString("en-US", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })
                              : "0.00"
                          }}
                        </h4>
                      </span>
                    </td>
                  </tr>

                  <tr>
                    <td scope="colgroup"
                      class="textalignleft caption prborderbottomsumpo tdborder-left width80 tdborder-bottom paddingleftintable">
                      <h4 class="textalignleft">
                        <span>
                          Less Withholding Tax / ภาษีเงินได้ หัก ณ ที่จ่าย ({{
                            print_header.wth_rate
                              ? print_header.wth_rate
                              : "0.00"
                          }}
                          %)</span>
                      </h4>
                    </td>
                    <td scope="colgroup"
                      class="textalignleft caption prborderbottomsumpo tdborder-left width20 tdborder-right tdborder-bottom paddingrightintable">
                      <span class="textalignright">
                        <h4>
                          {{
                            print_header.wth_rate_amount
                              ? print_header.wth_rate_amount.toLocaleString(
                                "en-US",
                                {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                }
                              )
                              : "0.00"
                          }}
                        </h4>
                      </span>
                    </td>
                  </tr>

                  <tr>
                    <td scope="colgroup"
                      class="textalignleft width100 caption prborderbottomsumpo tdborder-left tdborder-bottom paddingleftintable">
                      <h4>
                        <span class="textalignleft">
                          Value Added Tax / ภาษีมูลค่าเพิ่ม ({{
                            print_header.tax_rate
                              ? print_header.tax_rate
                              : "0.00"
                          }}
                          %)</span>
                      </h4>
                    </td>
                    <td scope="colgroup"
                      class="textalignleft width100 caption prborderbottomsumpo tdborder-left tdborder-right tdborder-bottom paddingrightintable">
                      <span class="textalignright">
                        <h4>
                          {{
                            print_header.tax_rate_amount
                              ? print_header.tax_rate_amount.toLocaleString(
                                "en-US",
                                {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                }
                              )
                              : "0.00"
                          }}
                        </h4>
                      </span>
                    </td>
                  </tr>

                  <tr>
                    <td scope="colgroup"
                      class="textalignleft width100 caption prborderbottomsumpo tdborder-left tdborder-bottom paddingleftintable">
                      <h4 class="textalignleft">
                        <span> Grand Total / ยอดรวม</span><br />
                        <span class="fixonerowcenter" style="display: table; margin: 0px auto 0px auto">({{
                          textamount_total_en }})</span>
                        <!-- background-color:#dedbdb; -->
                      </h4>
                    </td>
                    <td scope="colgroup"
                      class="textalignleft width100 caption prborderbottomsumpo tdborder-left tdborder-right tdborder-bottom paddingrightintable">
                      <span class="textalignright">
                        <h4>
                          {{
                            print_header.amount_total
                              ? print_header.amount_total.toLocaleString(
                                "en-US",
                                {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                }
                              )
                              : "0.00"
                          }}
                        </h4>
                      </span>
                    </td>
                  </tr>
                </table>

                <div class="rowprpo aligncenter mt30">
                  <div class="col-md-12report aligncenter">
                    <div class="aligncenter borderblack borderblockpr fontsize10">
                      <div class="aligncenter col-md-12report mt20">
                        <div class="col-md-12report">
                          _________________________________________
                        </div>
                        <div class="col-md-12report">
                          Authorized Signature / ผู้มีอำนาจลงนาม
                        </div>
                        <div class="col-md-12report">
                          Date / วันที่ _____________________________
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="rowprpo aligncenter col-md-12report fontsize10">
                  <div class="col-md-12report">
                    Please send us a certificate of above withholding income tax
                    issued to our firm together with your payment
                  </div>
                </div>
                <div class="rowprpo aligncenter col-md-12report fontsize10 mt-5prpo">
                  <div class="col-md-12report">
                    โปรดส่งหนังสือรับรองการหักภาษี ณ
                    ที่จ่ายมาพร้อมกับเอกสารชําระเงิน
                  </div>
                </div>
              </div>
            </div>
          </page>
          <page v-if="datashowAlltimesheet.length > 0" v-for="indextimesheet in datashowAlltimesheet.length" size="A4"
            class="aligncenter">
            <div class="aligncenter">
              <div class="rowprpo mr30prpo mt30">
                <div class="col-md-8report"></div>
                <div class="col-md-4report">
                  <h5 class="alignright colprpo">
                    No : {{ print_header.inv_id }}
                  </h5>
                </div>
              </div>
              <div class="rowprpo aligncenter">
                <div class="col-md-12report mt-30prpo">
                  <h3>
                    {{ print_header.com_title }}
                  </h3>
                </div>
              </div>
            </div>

            <div class="rowprpo caption ml30prpo mr30prpo" style="margin-top: 10px">
              <table class="captionhtable">
                <tr>
                  <th scope="colgroup"
                    class="prbordertop2pxhtable prborderbottom2pxhtable width15 thborder-top thborder-left fontsize13 captionhtable">
                    <span class="aligncenter">Date / วันที่ </span>
                  </th>
                  <th scope="colgroup"
                    class="prbordertop2pxhtable prborderbottom2pxhtable width15 thborder-top thborder-left fontsize13 captionhtable">
                    <span class="aligncenter">Lawyer </span>
                  </th>
                  <th scope="colgroup"
                    class="prbordertop2pxhtable prborderbottom2pxhtable width50 thborder-top thborder-left fontsize13 captionhtable">
                    <span class="aligncenter">Description / รายการ </span>
                  </th>
                  <th scope="colgroup"
                    class="prbordertop2pxhtable prborderbottom2pxhtable width20 thborder-top thborder-left thborder-right fontsize13 captionhtable">
                    <span class="aligncenter">Amount / จำนวนเงิน </span>
                  </th>
                </tr>
              </table>

              <table class="captionhtable" style="height: 965px">
                <tr v-for="(datatimsheet, itimsheet) in datashowAlltimesheet[
                  indextimesheet - 1
                ]" style="height: 20px">
                  <td style="position: relative" scope="colgroup"
                    class="textalignleft width15 caption prborderbottomsumpo tdborder-left fontsize13 paddingleftintable">
                    <span class="width100 textalignleft" style="vertical-align: top; position: absolute; top: 0px">
                      <span v-if="itimsheet == 0" class="fixonerow fontsize13"><br />
                      </span>
                      {{ datatimsheet.report_date }}</span>
                  </td>
                  <td style="position: relative" scope="colgroup"
                    class="textalignleft width15 caption prborderbottomsumpo tdborder-left fontsize13 paddingleftintable">
                    <span class="width100 textalignleft" style="vertical-align: top; position: absolute; top: 0px">
                      <span v-if="itimsheet == 0" class="fixonerow fontsize13"><br />
                      </span>
                      {{ datatimsheet.lawyer }}</span>
                  </td>
                  <td style="position: relative" scope="colgroup"
                    class="textalignleft width50 caption prborderbottomsumpo tdborder-left fontsize13 paddingleftintable">
                    <span v-if="itimsheet == 0" class="fixonerow fontsize13 titledatadetailintable">
                      Professional fee
                    </span>
                    <span class="textalignleft">
                      {{ datatimsheet.report_desc }}</span>
                  </td>
                  <td style="position: relative"
                    class="textalignleft width20 caption prborderbottomsumpo tdborder-left tdborder-right fontsize13">
                    <span class="width100 textalignright paddingrightintable"
                      style="vertical-align: top; position: absolute; top: 0px">
                      <span v-if="itimsheet == 0" class="fixonerow fontsize13"><br />
                      </span>
                      {{
                        datatimsheet.report_amount.toLocaleString("en-US", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })
                      }}</span>
                  </td>
                </tr>
                <tr>
                  <td scope="colgroup"
                    class="textalignleft width20 caption prborderbottomsumpo tdborder-left tdborder-bottom"></td>
                  <td scope="colgroup"
                    class="textalignleft width20 caption prborderbottomsumpo tdborder-left tdborder-bottom"></td>
                  <td scope="colgroup"
                    class="textalignleft width20 caption prborderbottomsumpo tdborder-left tdborder-bottom"></td>
                  <td scope="colgroup"
                    class="textalignleft width20 caption prborderbottomsumpo tdborder-left tdborder-right tdborder-bottom">
                  </td>
                </tr>
              </table>
            </div>
            <div class="footerprpo">
              <div class="rowprpo caption ml30prpo mr30prpo">
                <div class="rowprpo aligncenter col-md-12report fontsize10">
                  <div class="col-md-12report">
                    Please send us a certificate of above withholding income tax
                    issued to our firm together with your payment
                  </div>
                </div>
                <div class="rowprpo aligncenter col-md-12report fontsize10 mt-5prpo">
                  <div class="col-md-12report">
                    โปรดส่งหนังสือรับรองการหักภาษี ณ
                    ที่จ่ายมาพร้อมกับเอกสารชําระเงิน
                  </div>
                </div>
              </div>
            </div>
          </page>

          <page v-if="datashowAlltimekeeper.length > 0" size="A4" class="aligncenter">
            <div class="aligncenter">
              <div class="rowprpo mr30prpo mt30">
                <div class="col-md-8report"></div>
                <div class="col-md-4report">
                  <h5 class="alignright colprpo">
                    No : {{ print_header.inv_id }}
                  </h5>
                </div>
              </div>
              <div class="rowprpo aligncenter">
                <div class="col-md-12report mt-30prpo">
                  <h3>
                    {{ print_header.com_title }}
                  </h3>
                </div>
              </div>
            </div>

            <div class="rowprpo caption ml30prpo mr30prpo" style="margin-top: 10px">
              <table class="captionhtable">
                <tr>
                  <th scope="colgroup"
                    class="prbordertop2pxhtable prborderbottom2pxhtable width40 thborder-top thborder-left fontsize13 captionhtable">
                    <span class="aligncenter">Timekeepers </span>
                  </th>
                  <th scope="colgroup"
                    class="prbordertop2pxhtable prborderbottom2pxhtable width20 thborder-top thborder-left fontsize13 captionhtable">
                    <span class="aligncenter">Rate(Baht) </span>
                  </th>
                  <th scope="colgroup"
                    class="prbordertop2pxhtable prborderbottom2pxhtable width20 thborder-top thborder-left fontsize13 captionhtable">
                    <span class="aligncenter">Charge Hours </span>
                  </th>
                  <th scope="colgroup"
                    class="prbordertop2pxhtable prborderbottom2pxhtable width20 thborder-top thborder-left thborder-right fontsize13 captionhtable">
                    <span class="aligncenter">Charge Value(Baht) </span>
                  </th>
                </tr>
              </table>

              <table class="captionhtable" style="height: 965px">
                <tr v-for="(
datatimekeeper, indextimekeeper
                  ) in datashowAlltimekeeper" style="height: 20px">
                  <td style="position: relative" scope="colgroup"
                    class="textalignleft width40 caption prborderbottomsumpo tdborder-left fontsize13 paddingleftintable">
                    <span v-if="indextimekeeper == 0" class="fixonerow fontsize13 titledatadetailintable">
                      Timekeeper Details
                    </span>

                    <span class="width100 textalignleft">
                      {{ datatimekeeper.tc_name }}</span>
                  </td>
                  <td style="position: relative" scope="colgroup"
                    class="textalignleft width20 caption prborderbottomsumpo tdborder-left fontsize13">
                    <span class="width100 textalignright paddingrightintable"
                      style="vertical-align: top; position: absolute; top: 0px">
                      <span v-if="indextimekeeper == 0" class="fixonerow fontsize13"><br />
                      </span>
                      <span class="width100 textalignright">
                        {{ datatimekeeper.tc_rate_show }}</span>
                    </span>
                  </td>
                  <td style="position: relative" scope="colgroup"
                    class="textalignleft width20 caption prborderbottomsumpo tdborder-left fontsize13">
                    <span class="width100 textalignright paddingrightintable"
                      style="vertical-align: top; position: absolute; top: 0px">
                      <span v-if="indextimekeeper == 0" class="fixonerow fontsize13"><br />
                      </span>
                      <span class="width100 textalignright">
                        {{ datatimekeeper.tc_actualchargehour_show }}</span>
                    </span>
                  </td>
                  <td style="position: relative"
                    class="textalignleft width20 caption prborderbottomsumpo tdborder-left tdborder-right fontsize13">
                    <span class="width100 textalignright paddingrightintable"
                      style="vertical-align: top; position: absolute; top: 0px">
                      <span v-if="indextimekeeper == 0" class="fixonerow fontsize13"><br />
                      </span>
                      <span class="width100 textalignright">
                        {{ datatimekeeper.tc_rateChargeHour_bath_show }}</span>
                      <span v-if="
                        indextimekeeper == datashowAlltimekeeper.length - 1
                      " class="width100 textalignright doubleunderline">
                        <br />
                        {{
                          print_header.ts_total.toLocaleString("en-US", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })
                        }}</span>
                    </span>
                  </td>
                </tr>
                <tr>
                  <td scope="colgroup"
                    class="textalignleft width40 caption prborderbottomsumpo tdborder-left tdborder-bottom"></td>
                  <td scope="colgroup"
                    class="textalignleft width20 caption prborderbottomsumpo tdborder-left tdborder-bottom"></td>
                  <td scope="colgroup"
                    class="textalignleft width20 caption prborderbottomsumpo tdborder-left tdborder-bottom"></td>
                  <td scope="colgroup"
                    class="textalignleft width20 caption prborderbottomsumpo tdborder-left tdborder-right tdborder-bottom">
                  </td>
                </tr>
              </table>
            </div>
            <div class="footerprpo">
              <div class="rowprpo caption ml30prpo mr30prpo">
                <div class="rowprpo aligncenter col-md-12report fontsize10">
                  <div class="col-md-12report">
                    Please send us a certificate of above withholding income tax
                    issued to our firm together with your payment
                  </div>
                </div>
                <div class="rowprpo aligncenter col-md-12report fontsize10 mt-5prpo">
                  <div class="col-md-12report">
                    โปรดส่งหนังสือรับรองการหักภาษี ณ
                    ที่จ่ายมาพร้อมกับเอกสารชําระเงิน
                  </div>
                </div>
              </div>
            </div>
          </page>
        </div>
      </template>

      <v-dialog v-model="dialogDeleteForm" max-width="500px">
        <v-card>
          <v-card-title class="text-h6">Are you sure you want to delete this Invoice?</v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="closeDeleteForm">Cancel</v-btn>
            <v-btn color="blue darken-1" text @click="deleteItemConfirmForm">OK</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogDelete" max-width="500px">
        <v-card>
          <v-card-title class="text-h5">Are you sure you want to delete this file?</v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
            <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <SuccessDialog :status="dialogAdd" :text_color="text_color" :title="title" :message="message" />
      <SuccessDialogPush :status="dialogAdd" :text_color="text_color" :title="title" :message="message" :link="link" />
    </v-card>
  </v-container>
</template>

<script>
import SuccessDialog from "@/components/cards/SuccessDialog";
import SuccessDialogPush from "@/components/cards/SuccessDialogPush";
import api from "@/services/api";
import { server } from "@/services/constants";
import InvoiceFreeTextSalseorderTab from "./InvoiceFreeTextSalseorderTab";
import InvoiceFreetextTimesheetTab from "./InvoiceFreetextTimesheetTab";
import InvoiceFreetextAdvanceTab from "./InvoiceFreetextAdvanceTab";
import InvoiceMiscellaneousTab from "./InvoiceMiscellaneousTab";
import AdditionalNoteTab from "./AdditionalNoteTab";
import {
  tolocalestringnumber,
  stringcommatonumber,
} from "../computing/tolocalestringnumber";
var convert = require("decimal-number-to-words");
import html2pdf from "html2pdf.js";
import unity from "@/unity/unity";
import pdfvuer from "pdfvuer";

export default {
  async beforeMount() {
    this.$showLoader();
    this.caltotalAll();
    await this.loadCustomer();
    if (this.$route.params.mode == "invoice") {
      this.titleheader = "Free Text Invoice";
      this.add_h.inv_type = "I";
      this.callsoopentab = true;
    } else if (this.$route.params.mode == "performa") {
      this.titleheader = "Free Text  Proforma Invoice";
      this.add_h.inv_type = "P";
      this.callsoopentab = true;
    } else {
      this.getdatafrominv_h = true;
      this.loaddatainv();
    }
    if (
      this.$route.params.customer_id &&
      this.$route.params.menurequest == "IM"
    ) {
      this.menurequest = this.$route.params.menurequest;
      this.add_h.dept_type = "IM";
      this.customer_name_list.forEach((x, index) => {
        if (x.id == this.$route.params.customer_id) {
          this.cus_code = x.cust_account;
        }
      });
    } else if (
      this.$route.params.customer_id &&
      this.$route.params.menurequest == "Litigations"
    ) {
      this.menurequest = this.$route.params.menurequest;
      this.module_id = Number(this.$route.query.module_id)
      this.add_h.dept_type = "Litigations";
      this.customer_name_list.forEach((x, index) => {
        if (x.id == this.$route.params.customer_id) {
          this.cus_code = x.cust_account;
        }
      });
      console.log(this.cus_code)
    } else if (
      this.$route.params.customer_id &&
      this.$route.params.menurequest == "Incorporation"
    ) {
      this.menurequest = this.$route.params.menurequest;
      this.module_id = Number(this.$route.query.module_id)
      this.add_h.dept_type = "Incorporation";
      this.customer_name_list.forEach((x, index) => {
        if (x.id == this.$route.params.customer_id) {
          this.cus_code = x.cust_account;
        }
      });
    } else if (
      this.$route.params.customer_id &&
      this.$route.params.menurequest == "Immigration"
    ) {
      this.menurequest = this.$route.params.menurequest;
      this.moduleIdList = String(this.$route.query.module_id)
        .split(",")
        .map((id) => id.trim())
        .filter((id) => id !== "")
        .map(Number);
      this.add_h.dept_type = "Immigration";
      this.customer_name_list.forEach((x, index) => {
        if (x.id == this.$route.params.customer_id) {
          this.cus_code = x.cust_account;
        }
      });
    } else if (
      this.$route.params.customer_id &&
      this.$route.params.menurequest == "IP"
    ) {
      this.menurequest = this.$route.params.menurequest;
      this.add_h.dept_type = "IP";
      this.customer_name_list.forEach((x, index) => {
        if (x.id == this.$route.params.customer_id) {
          this.cus_code = x.cust_account;
        }
      });
    } else if (
      this.$route.params.customer_id &&
      this.$route.params.menurequest == "Docket"
    ) {
      this.menurequest = this.$route.params.menurequest;
      this.add_h.dept_type = "IP";
      this.customer_name_list.forEach((x, index) => {
        if (x.id == this.$route.params.customer_id) {
          this.cus_code = x.cust_account;
        }
      });

      this.docketIdList = String(this.$route.query.docketId)
        .split(",")
        .map((id) => id.trim())
        .filter((id) => id !== "");
    } else {
      this.add_h.dept_type = "FreeText";
    }
    this.$hideLoader();
  },
  async mounted() {
    this.$showLoader();
    this.caltotalAll();
    await this.loadDepartmentByCompanyId();
    await this.loadCustomer();
    // this.$showLoader();
    if (this.$route.params.mode == "invoice") {
      this.titleheader = "Free Text Invoice";
      this.add_h.inv_type = "I";
      this.add_h.company_inv = this.$route.params.company_inv;
      this.callsoopentab = true;
    } else if (this.$route.params.mode == "performa") {
      this.titleheader = "Free Text  Proforma Invoice";
      this.add_h.inv_type = "P";
      this.add_h.company_inv = this.$route.params.company_inv;
      this.callsoopentab = true;
    } else {
      this.getdatafrominv_h = true;
      await this.loaddatainv();
    }
    if (
      this.$route.params.customer_id &&
      this.$route.params.menurequest == "IM"
    ) {
      this.menurequest = this.$route.params.menurequest;
      this.add_h.dept_type = "IM";
      this.customer_name_list.forEach((x, index) => {
        if (x.id === this.$route.params.customer_id) {
          this.cus_code = x.cust_account;
        }
      });
    } else if (
      this.$route.params.customer_id &&
      this.$route.params.menurequest == "Incorporation"
    ) {
      this.menurequest = this.$route.params.menurequest;
      this.add_h.dept_type = "Incorporation";
      this.customer_name_list.forEach((x, index) => {
        if (x.id === this.$route.params.customer_id) {
          this.cus_code = x.cust_account;
        }
      });
    } else if (
      this.$route.params.customer_id &&
      this.$route.params.menurequest == "Immigration"
    ) {
      this.menurequest = this.$route.params.menurequest;
      this.add_h.dept_type = "Immigration";
      this.moduleIdList = String(this.$route.query.module_id)
        .split(",")
        .map((id) => id.trim())
        .filter((id) => id !== "")
        .map(Number);
      this.customer_name_list.forEach((x, index) => {
        if (x.id === this.$route.params.customer_id) {
          this.cus_code = x.cust_account;
        }
      });
    } else if (
      this.$route.params.customer_id &&
      this.$route.params.menurequest == "IP"
    ) {
      this.menurequest = this.$route.params.menurequest;
      this.add_h.dept_type = "IP";
      this.customer_name_list.forEach((x, index) => {
        if (x.id == this.$route.params.customer_id) {
          this.cus_code = x.cust_account;
        }
      });
    } else if (
      this.$route.params.customer_id &&
      this.$route.params.menurequest == "Docket"
    ) {

      this.menurequest = this.$route.params.menurequest;
      this.$route.params.menurequest == "Docket";
      this.add_h.dept_type = "IP";
      this.customer_name_list.forEach((x, index) => {
        if (x.id == this.$route.params.customer_id) {
          this.cus_code = x.cust_account;
        }
      });

    } else {
      this.add_h.dept_type = "FreeText";
    }

    this.$hideLoader();
  },
  components: {
    SuccessDialog,
    SuccessDialogPush,
    InvoiceFreeTextSalseorderTab,
    InvoiceFreetextTimesheetTab,
    InvoiceFreetextAdvanceTab,
    InvoiceMiscellaneousTab,
    AdditionalNoteTab,
  },
  computed: {
    version() {
      return this.initial_data;
    },
    formTitle() {
      return this.editedIndex === -1 ? "New Item" : "Edit Item";
    },
    computedDateFormatted() {
      return unity.formatDate(this.date);
    },
  },
  data() {
    return {
      //file
      module_id: 0,
      docketIdList: [],
      moduleIdList: [],
      preview_list2: [],
      getpreview_list: [],
      image: null,
      previewimage: null,
      previewimageedit: null,
      image_list: [],
      preview_list: [],
      dialogpreviewimage: false,
      checkfileapreview: false,
      previewpopupfile: [],
      previewpopupfile2: [],
      dialogpreviewfile: false,
      dialogDelete: false,
      dialogDeleteimage: false,
      filename: [],
      imagename: "",
      load_bg: false,
      checkfileadd: false,
      checkimageadd: false,
      //--
      po_no_cus: "",
      attention_cus: "",
      contact_position_cus: "",
      contact_position: "",
      vat_type: "",
      vat_type_cus: "",
      vat_cus: 0,
      payment_term_cus: 0,
      cusid_freetext_ts: 0,
      cus_code: "",
      Cus_Data: {},
      selected_showE: [],
      oper_sel: 1,
      inv_ts_list: [],
      selected_showAv: [],
      oper_sel_Av: 1,
      callsoopentab: false,
      dialogDeleteForm: false,
      datainv_disable: false,
      showinv_id: "####",
      menu2: false,
      desserts: [],
      getdatefrom_inv_so: [],
      getdatafrominv_h: false,
      dialogAdd: false,
      text_color: "text-h5 green--text text-center",
      title: "green",
      message: "green",
      link: "",
      addinv_docref_so: {
        inv_hid: 0,
        ref_type: "SO",
        ref_id: 0,
      },
      addinv_docref_ts: {
        inv_hid: 0,
        ref_type: "TS",
        ref_id: 0,
      },
      addinv_docref_ad: {
        inv_hid: 0,
        ref_type: "AD",
        ref_id: 0,
      },
      addinv_so: {
        inv_hid: 0,
        so_seq: 0,
        item_id: "",
        item_name: "",
        item_qty: 0,
        item_um: "",
        item_price: 0,
        item_disc: 0,
        item_line_amt: 0,
        user_create: localStorage.getItem(server.USER_ID),
      },
      getdatefrom_inv_h: {
        customerid: 0,
        customer_code: "",
        customer_name: "",
        customer_address: "",
        customer_taxid: "",
        customer_branch: "",
        customer_paymentterm: 0,
        customer_vat: 0,
        vat_type: "",
        saleorder_id: "",
        currency: "",
      },
      period_cover: "",
      wth_rate: 0,
      tax_rate: 0,
      wth_ratetotal: 0,
      tax_ratetotal: 0,
      amount_total: 0,
      invoice_address: "",
      so_total: 0,
      ts_total: 0,
      ad_total: this.$store.state.inv_advance_total,
      mis_total: this.$store.state.inv_miscellaneous_total,
      inv_subtotal: 0,
      titleheader: "Invoice",
      activetab: 1,
      isShowPassword: false,
      fullPage: true,
      date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      dateCurrent: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      add_h: {
        inv_id: "",
        pinv_id: "",
        company_id: localStorage.getItem(server.COMPANYID),
        inv_date: "",
        period_cover: "",
        inv_type: "",
        customerid: 0,
        customer_address: "",
        customer_taxid: "",
        customer_branch: "",
        customer_paymentterm: 0,
        customer_vat: 0,
        vat_type: "",
        so_total: 0,
        ts_total: 0,
        ad_total: 0,
        mis_total: 0,
        sub_total: 0,
        wth_rate: 0,
        tax_rate: 0,
        amount_total: 0,
        company_inv: "",
        status: 0,
        so_ref: 0,
        additional_top: "",
        additional_bottom: "",
        dept: parseInt(localStorage.getItem(server.DEPARTMENT_ID)),
        dept_type: "",
        user_create: localStorage.getItem(server.USER_ID),
      },
      disableinstatus: false,
      ts_status_oper: "",
      tsTAB_IdforCus: this.$route.params.id,
      getdataByCusStatus: "",
      ts_id: [],
      ad_id: [],
      ts_idTab: [],
      ad_idTab: [],
      ts_idTab: 0,
      datainv_mis: [],
      ad_inv_id: [],
      id_invoice: 0,
      print_header_list: [
        {
          id: "1",
          com_title: "STATEMENT",
          com_eng_1: "DEJ-UDOM & ASSOCIATES LTD.",
          com_eng_2: "ATTORNEYS AT LAW",
          com_thai: "บริษัท เดชอุดม แอนด์ แอสโซซิเอทส์ จำกัด",
          com_add_name: "CHARN ISSARA TOWER 1, 2nd FLOOR,",
          com_add_no: "942/69 RAMA IV ROAD,",
          com_add_city: "KWAENG SURIYAWONG, KHET BANGRAK,",
          com_add_country: "BANGKOK 10500, THAILAND",
          com_add_tel: "Tel : 0-2233-0055, 0-2267-5152",
          com_add_fax: "Fax : 0-2236-6681, 0-2233-0227",
          com_add_email: "E-MAIL : account@dejudom.com",
          com_add_tax_id: `TAX I.D. No. 0992000028227/"HEAD OFFICE"`,
        },
        {
          id: "2",
          com_title: "STATEMENT",
          com_eng_1: "DEJ-UDOM & ASSOCIATES",
          com_eng_2: "ATTORNEYS AT LAW",
          com_thai: "สำนักกฎหมาย เดชอุดม แอนด์ แอสโซซิเอทส์",
          com_add_name: "CHARN ISSARA TOWER 1, 2nd FLOOR,",
          com_add_no: "942/69 RAMA IV ROAD,",
          com_add_city: "KWAENG SURIYAWONG, KHET BANGRAK,",
          com_add_country: "BANGKOK 10500, THAILAND",
          com_add_tel: "Tel : 0-2233-0055, 0-2267-5152",
          com_add_fax: "Fax : 0-2236-6681, 0-2233-0227",
          com_add_email: "E-MAIL : account@dejudom.com",
          com_add_tax_id: `TAX I.D. No. 0992000028227`,
        },
      ],
      print_header: null,
      print_table_detail: [],
      pageAll: 1,
      opensummarize: false,
      datashowAll: [],
      setdatatoshow: [],
      dataforshowprpo: [],
      getheightcontentpr: 0,
      opensummarizetimesheet: false,
      pageAlltimesheet: 1,
      setdatatoshowtimesheet: [],
      print_table_detailtimesheet: [],
      datashowAlltimesheet: [],
      print_detail_timekeeper: [],
      datashowAlltimekeeper: [],
      showprint: "display:none;",
      haveSO: false,
      haveAD: false,
      indexinvADMIS: false,
      customer_name_list: [],
      menurequest: "",
      disabled_dep: false,
      department_list: [],
      getaccount_userid: [],
    };
  },
  methods: {
    async loadDepartmentByCompanyId() {
      let result = await api.getNewAllDepartment_By_CompanyID(
        localStorage.getItem(server.COMPANYID)
      );
      this.department_list = result.data;
      const res_user = await api.getAccountid(
        Number(localStorage.getItem(server.USER_ID))
      );
      this.getaccount_userid = res_user.data[0].firstname
        ? `${res_user.data[0].firstname} ${res_user.data[0].lastname}`
        : `${res_user.data[0].firstname_e_n} ${res_user.data[0].lastname_e_n}`;

      if (
        Number(res_user.data[0].department_i_d) != 6 &&
        Number(localStorage.getItem(server.USER_ID)) != 1
      ) {
        this.disabled_dep = true;
      } else {
        this.disabled_dep = false;
      }
    },
    async loadCustomer() {
      const result = await api.getAllCustomerListactiveCompany({
        params: {
          company_id: localStorage.getItem(server.COMPANYID),
        },
      });

      this.customer_name_list = result.data;
    },
    async exportToPDF(advance_id) {
      // this.$refs.html2Pdf.generatePdf();

      this.showprint = "";
      let element = document.getElementById("mydivhtmltobase");
      const opt = {
        margin: [0, 0, 0, 0],
        image: {
          type: "jpeg",
          quality: 0.98,
        },
        // enableLinks: false,
        html2canvas: {
          scale: 2,
          dpi: 192,
          letterRendering: true,
          useCORS: true,
          // ignoreElements: (e) => {
          //   return e.classList.contains("cke_pagebreak") ||
          //     e.classList.contains("html2pdf__page-break")
          //     ? true
          //     : false;
          // },
        },
        jsPDF: {
          unit: "cm",
          format: "A4",
          orientation: "portrait",
          putOnlyUsedFonts: true,
          pagesplit: true,
        },
        // pagebreak: { mode: ["avoid-all"], after: ".cke_pagebreak" },
      };

      let abcd = await html2pdf()
        .from(element)
        .set(opt)
        .toPdf()
        .get("pdf")
        // .output("bloburl")
        .then(function (pdf) {
          const totalPages = pdf.internal.getNumberOfPages();
          pdf.deletePage(totalPages);
          return pdf.output("bloburl");
        });

      window.open(abcd);
      let blob = await fetch(abcd).then((r) => r.blob());
      this.showprint = "display:none;";

      return;
    },
    async getPrintOutData() {
      this.inv_id = this.id_invoice;
      // this.showprint = "";
      this.haveSO = false;
      this.haveAD = false;
      this.datashowAll = [];
      this.print_table_detail = [];
      this.print_table_detailtimesheet = [];
      this.print_detail_timekeeper = [];
      this.dialogPrintOut = false;
      // alert(`Print Out Invoice ID: ${this.inv_id}, ${this.dialogPrintOutData}`);
      // if (this.dialogPrintOutData == "1") {
      //   this.print_header = this.print_header_list[0];
      // } else if (this.dialogPrintOutData == "2") {
      //   this.print_header = this.print_header_list[1];
      // }

      this.$showLoader();

      await this.loadRef_TypeCNById();
      await this.loadInvSoData();
      // await this.loadMainInvSoData();
      // await this.loadInvADData();
      await this.loadInvDocRefData();
      await this.loadInvTSGetTimekeeper();
      await this.loadInvMISData();
      await this.checkcontent();
      await this.checkcontenttimesheet();
      await this.exportToPDF();
      // this.showprint = "display:none;";
      this.$hideLoader();
    },
    async loadRef_TypeCNById() {
      // const res_docref_so = await api.getRef_TypeCNById(this.inv_id);

      const res_hresult = await api.getdataByIdInvoice_H(this.inv_id);

      if (res_hresult.data[0].company_inv == "D") {
        this.print_header = this.print_header_list[0];
      } else if (res_hresult.data[0].company_inv == "L") {
        this.print_header = this.print_header_list[1];
      }

      this.print_header.inv_id = res_hresult.data[0].inv_id
        ? res_hresult.data[0].inv_id
        : res_hresult.data[0].pinv_id;
      this.print_header.customer_name = res_hresult.data[0].customer_name;
      this.print_header.invoice_date = res_hresult.data[0].date;
      this.print_header.addressall = res_hresult.data[0].addressall;
      this.print_header.customer_address = res_hresult.data[0].customer_address;

      this.print_header.province_invoice = res_hresult.data[0].province_invoice;
      this.print_header.country_invoice = res_hresult.data[0].country_invoice;
      this.print_header.zipcode_invoice = res_hresult.data[0].zipcode_invoice;

      this.print_header.period_cover = res_hresult.data[0].period_cover;
      this.print_header.customer_contact_name =
        res_hresult.data[0].customer_contact_name;
      this.print_header.customer_taxid = res_hresult.data[0].customer_taxid;

      this.print_header.ts_total = parseFloat(res_hresult.data[0].ts_total);
      this.print_header.sub_total = parseFloat(res_hresult.data[0].sub_total);
      this.print_header.wth_rate = res_hresult.data[0].wth_rate;
      this.print_header.tax_rate = res_hresult.data[0].tax_rate;
      this.print_header.wth_rate_amount = parseFloat(
        (res_hresult.data[0].sub_total * res_hresult.data[0].wth_rate) / 100
      );
      this.print_header.tax_rate_amount = parseFloat(
        (res_hresult.data[0].sub_total * res_hresult.data[0].tax_rate) / 100
      );

      this.textamount_total_en = convert.toWords(
        res_hresult.data[0].amount_total
      );
      this.print_header.amount_total = parseFloat(
        res_hresult.data[0].amount_total
      );
    },
    async loadInvSoData() {
      var tmp_inv_data;
      const res_inv_so = await api.printInvSO(this.inv_id);

      tmp_inv_data = res_inv_so.data;
      if (tmp_inv_data.length > 0) {
        this.haveSO = true;
      }

      tmp_inv_data.forEach((inv_so, index) => {
        var data = {
          report_type: "SO",
          report_desc: "",
          report_amount: 0,
          first_item: 0,
          solastdata: "",
        };
        if (index == tmp_inv_data.length - 1) {
          data.solastdata = "SOlastindex";
        }
        // if (index == 0) {
        //   data.first_item = 1;
        // }

        data.report_desc = inv_so.report_desc;
        data.report_amount = parseFloat(inv_so.report_amount);
        this.print_table_detail.push(data);
      });
    },
    async loadInvDocRefData() {
      const res_inv_doc_ref = await api.printInvDocRef(this.inv_id);

      this.indexinvADMIS = true;

      for await (const inv_doc_ref of res_inv_doc_ref.data) {
        if (inv_doc_ref.ref_type == "AD") {
          await this.loadInvAdvanceDetailData(inv_doc_ref.ref_id);
        }

        if (inv_doc_ref.ref_type == "TS") {
          await this.loadInvTimeSheetDetailData(inv_doc_ref.ref_id);
        }
      }

      // this.dataforshowprpo = this.print_table_detail;

      // await this.checkcontent();
    },
    async loadInvTSGetTimekeeper() {
      this.datashowAlltimekeeper = [];
      if (this.print_detail_timekeeper.length <= 0) {
        return;
      }
      let data = {};
      data.hid = this.print_detail_timekeeper;

      const resultc = await api.getAllBytimesheetCreeper_hid(data);
      this.datashowAlltimekeeper = resultc.data;
      this.datashowAlltimekeeper.forEach((item) => {
        item.tc_rateChargeHour_bath = (
          (Number(item.tc_actualchargehour) / 60) *
          Number(item.tc_rate)
        ).toFixed(2);
        item.tc_nocharge = Math.abs(
          (
            (Number(item.tc_actualchargehour) - Number(item.tc_hours)) /
            60
          ).toFixed(2)
        );
        item.tc_nochargeCal = (
          Math.abs(
            (Number(item.tc_actualchargehour) - Number(item.tc_hours)) / 60
          ) * Number(item.tc_rate)
        ).toFixed(2);

        //sum all
        this.sum_chargehour =
          this.sum_chargehour + Number(item.tc_actualchargehour / 60);
        this.sum_rateChargehour =
          this.sum_rateChargehour + Number(item.tc_rateChargeHour_bath);
        this.sum_noCharge_hour =
          this.sum_noCharge_hour + Number(item.tc_nocharge);
        this.sum_noCharge_bath =
          this.sum_noCharge_bath + Number(item.tc_nochargeCal);
        this.sum_grandTotal = this.sum_rateChargehour;

        // //show data in table
        item.tc_rate_show = tolocalestringnumber(item.tc_rate);
        item.tc_actualchargehour_show = tolocalestringnumber(
          Number(item.tc_actualchargehour / 60).toFixed(2)
        );
        item.tc_rateChargeHour_bath_show = tolocalestringnumber(
          item.tc_rateChargeHour_bath
        );
        item.tc_nocharge_show = tolocalestringnumber(item.tc_nocharge);
        item.tc_nochargeCal_show = tolocalestringnumber(item.tc_nochargeCal);
      });
    },
    async loadInvMISData() {
      var tmp_inv_data;
      // const res_docref_so = await api.getRef_TypeCNById(this.inv_id);
      const res_inv_mis = await api.printInvMIS(this.inv_id);

      tmp_inv_data = res_inv_mis.data;

      tmp_inv_data.forEach((inv_mis, index) => {
        var data = {
          report_type: "ADMIS",
          report_desc: "",
          report_amount: 0,
          first_item: 0,
        };

        if (index == 0 && this.haveAD == false) {
          data.first_item = 1;
        }
        data.report_desc = inv_mis.report_desc;
        data.report_amount = parseFloat(inv_mis.report_amount);
        this.print_table_detail.push(data);
      });
    },
    async loadInvTimeSheetDetailData(ref_id) {
      var tmp_inv_data;
      this.print_detail_timekeeper.push(ref_id);
      const res_inv_time_sheet_detail = await api.printInvTS(ref_id);

      tmp_inv_data = res_inv_time_sheet_detail.data;

      tmp_inv_data.forEach((inv_time_sheet_detail) => {
        var data = {
          report_type: "TS",
          report_desc: "",
          report_amount: 0,
          report_date: "",
          lawyer: "",
        };

        data.report_desc = inv_time_sheet_detail.report_desc;
        data.report_amount = parseFloat(inv_time_sheet_detail.report_amount);
        data.report_date = inv_time_sheet_detail.report_date;
        data.lawyer = inv_time_sheet_detail.lawyer;
        this.print_table_detailtimesheet.push(data);
      });
    },
    async loadInvAdvanceDetailData(ref_id) {
      var tmp_inv_data;
      const res_inv_advance_detail = await api.printInvAD(ref_id);

      tmp_inv_data = res_inv_advance_detail.data;
      if (tmp_inv_data.length > 0) {
        this.haveAD = true;
      }

      tmp_inv_data.forEach((inv_advance_detail, index) => {
        var data = {
          report_type: "ADMIS",
          report_desc: "",
          report_amount: 0,
          first_item: 0,
        };
        if (this.indexinvADMIS == true && index == 0) {
          data.first_item = 1;
        }

        data.report_desc = inv_advance_detail.report_desc;
        data.report_amount = parseFloat(inv_advance_detail.report_amount);
        this.print_table_detail.push(data);
      });
      this.indexinvADMIS = false;
    },
    async checkcontent() {
      this.datashowAll = [];
      // alert(data.length);
      this.setdatatoshow = [];
      let linedetailprpo = 23;
      let datainlineprpo = 80;
      let addnewbutget = 1;
      let getdata = [];
      let getnewdata = [];
      let hllinedetails = 0;
      this.pageAll = 1;
      let newhllinedetails = 0;
      for (let i = 0; i < this.print_table_detail.length; i++) {
        let stringchecklength = "";
        let lengthofdataforshowprpo =
          this.print_table_detail[i].report_desc.length;

        let maiek = "่"; //ไม้เอก
        let maito = "้"; //ไม้โท
        let maitree = "๊"; //ไม้ตรี
        let maijattawa = "๋"; //ไม้จัตวา
        let vowelei = "ิ"; //สระอิ
        let vowelee = "ี"; //สระอี
        let voweleue = "ึ"; //สระอึ
        let voweleu = "ื"; //สระอือ
        let vowelu = "ุ"; //สระอุ
        let voweluu = "ู"; //สระอู
        let maihun = "ั"; //ไม้หันอากาศ
        let maiyamok = "็"; //ไม้เอก
        newhllinedetails = 0;
        getnewdata = [];
        this.print_table_detail[i].no = i + 1;

        for (
          let j = 0;
          j < this.print_table_detail[i].report_desc.length;
          j++
        ) {
          if (
            stringchecklength[j] == maiek ||
            stringchecklength[j] == maito ||
            stringchecklength[j] == maitree ||
            stringchecklength[j] == maijattawa ||
            stringchecklength[j] == vowelei ||
            stringchecklength[j] == vowelee ||
            stringchecklength[j] == voweleue ||
            stringchecklength[j] == voweleu ||
            stringchecklength[j] == vowelu ||
            stringchecklength[j] == voweluu ||
            stringchecklength[j] == maihun ||
            stringchecklength[j] == maiyamok
          ) {
            lengthofdataforshowprpo--;
          }
        }
        newhllinedetails = Math.ceil(lengthofdataforshowprpo / datainlineprpo);

        if (
          this.print_table_detail[i].first_item == 1 ||
          this.print_table_detail[i].solastdata == "SOlastindex" ||
          this.haveSO == false
        ) {
          newhllinedetails + 2;
        }

        // newhllinedetails = Math.ceil(
        //   this.print_table_detail[i].NAME.length / datainlineprpo
        // );

        // newhllinedetails += addnewbutget;
        getnewdata.push(this.print_table_detail[i]);

        if (hllinedetails + newhllinedetails > linedetailprpo) {
          this.setdatatoshow[this.pageAll - 1] = getdata;
          this.pageAll++;

          hllinedetails = 0;
          getdata = [];
          getdata.push(this.print_table_detail[i]);
          hllinedetails += newhllinedetails;
          if (i == this.print_table_detail.length - 1) {
            this.setdatatoshow[this.pageAll - 1] = getdata;
            getdata = [];
          }
        } else {
          hllinedetails += newhllinedetails;

          getdata.push(this.print_table_detail[i]);

          if (i == this.print_table_detail.length - 1) {
            this.setdatatoshow[this.pageAll - 1] = getdata;
            getdata = [];
          }
        }
      }
      this.opensummarize = true;

      this.setdatatoshow.forEach((item, iitem) => {
        if (iitem == this.setdatatoshow.length - 1) {
          item[this.setdatatoshow[iitem].length - 1].lastdata = "lastindex";
        }

        this.datashowAll.push(item);
      });
    },

    async checkcontenttimesheet() {
      this.datashowAlltimesheet = [];
      // alert(data.length);
      this.setdatatoshowtimesheet = [];
      let linedetailprpo = 42;
      let datainlineprpo = 60;
      let addnewbutget = 1;
      let getdata = [];
      let getnewdata = [];
      let hllinedetails = 0;
      this.pageAlltimesheet = 1;
      let newhllinedetails = 0;
      for (let i = 0; i < this.print_table_detailtimesheet.length; i++) {
        let stringchecklength = "";
        let lengthofdataforshowprpo =
          this.print_table_detailtimesheet[i].report_desc.length;

        let maiek = "่"; //ไม้เอก
        let maito = "้"; //ไม้โท
        let maitree = "๊"; //ไม้ตรี
        let maijattawa = "๋"; //ไม้จัตวา
        let vowelei = "ิ"; //สระอิ
        let vowelee = "ี"; //สระอี
        let voweleue = "ึ"; //สระอึ
        let voweleu = "ื"; //สระอือ
        let vowelu = "ุ"; //สระอุ
        let voweluu = "ู"; //สระอู
        let maihun = "ั"; //ไม้หันอากาศ
        let maiyamok = "็"; //ไม้เอก
        newhllinedetails = 0;
        getnewdata = [];
        this.print_table_detailtimesheet[i].no = i + 1;

        for (
          let j = 0;
          j < this.print_table_detailtimesheet[i].report_desc.length;
          j++
        ) {
          if (
            stringchecklength[j] == maiek ||
            stringchecklength[j] == maito ||
            stringchecklength[j] == maitree ||
            stringchecklength[j] == maijattawa ||
            stringchecklength[j] == vowelei ||
            stringchecklength[j] == vowelee ||
            stringchecklength[j] == voweleue ||
            stringchecklength[j] == voweleu ||
            stringchecklength[j] == vowelu ||
            stringchecklength[j] == voweluu ||
            stringchecklength[j] == maihun ||
            stringchecklength[j] == maiyamok
          ) {
            lengthofdataforshowprpo--;
          }
        }
        newhllinedetails = Math.ceil(lengthofdataforshowprpo / datainlineprpo);

        // newhllinedetails = Math.ceil(
        //   this.print_table_detailtimesheet[i].NAME.length / datainlineprpo
        // );

        // newhllinedetails += addnewbutget;
        getnewdata.push(this.print_table_detailtimesheet[i]);

        if (hllinedetails + newhllinedetails > linedetailprpo) {
          this.setdatatoshowtimesheet[this.pageAlltimesheet - 1] = getdata;
          this.pageAlltimesheet++;

          hllinedetails = 0;
          getdata = [];
          getdata.push(this.print_table_detailtimesheet[i]);
          hllinedetails += newhllinedetails;
          if (i == this.print_table_detailtimesheet.length - 1) {
            this.setdatatoshowtimesheet[this.pageAlltimesheet - 1] = getdata;
            getdata = [];
          }
        } else {
          hllinedetails += newhllinedetails;

          getdata.push(this.print_table_detailtimesheet[i]);

          if (i == this.print_table_detailtimesheet.length - 1) {
            this.setdatatoshowtimesheet[this.pageAlltimesheet - 1] = getdata;
            getdata = [];
          }
        }
      }
      this.opensummarizetimesheet = true;

      this.setdatatoshowtimesheet.forEach((item, iitem) => {
        if (iitem == this.setdatatoshowtimesheet.length - 1) {
          item[this.setdatatoshowtimesheet[iitem].length - 1].lastdata =
            "lastindex";
        }

        this.datashowAlltimesheet.push(item);
      });
    },

    async loaddatainv() {
      this.$showLoader();
      const res_hresult = await api.getdataByIdInvoice_H(this.$route.params.id);
      const res_docref_so = await api.getRef_TypeSOById(this.$route.params.id);

      this.id_invoice = res_hresult.data[0].id;
      this.date = res_hresult.data[0].date;
      this.period_cover = res_hresult.data[0].period_cover;
      this.add_h.inv_id = res_hresult.data[0].inv_id;
      this.add_h.pinv_id = res_hresult.data[0].pinv_id;
      if (this.add_h.inv_id) {
        this.showinv_id = this.add_h.inv_id;
      } else if (this.add_h.pinv_id) {
        this.showinv_id = this.add_h.pinv_id;
      } else {
        this.showinv_id = "####";
      }
      if (
        res_hresult.data[0].status == "P.invoice" ||
        res_hresult.data[0].status == "Invoice"
      ) {
        this.datainv_disable = true;
        this.ts_status_oper = "Submit";
      } else {
        this.ts_status_oper = "draft";
      }
      this.add_h.inv_type = res_hresult.data[0].inv_type;
      this.add_h.customerid = res_hresult.data[0].customer_id;
      this.add_h.customer_address = res_hresult.data[0].customer_address;
      this.add_h.customer_taxid = res_hresult.data[0].customer_taxid;
      this.add_h.customer_branch = res_hresult.data[0].customer_branch;
      this.add_h.customer_paymentterm =
        res_hresult.data[0].customer_paymentterm;
      this.add_h.customer_vat = res_hresult.data[0].customer_vat;
      this.add_h.vat_type = res_hresult.data[0].vat_type;
      this.add_h.company_inv = res_hresult.data[0].company_inv;
      this.add_h.additional_top = res_hresult.data[0].additional_top;
      this.add_h.additional_bottom = res_hresult.data[0].additional_bottom;

      this.getdatefrom_inv_h.customerid = res_hresult.data[0].customer_id;
      this.getdatefrom_inv_h.customer_code = res_hresult.data[0].customer_code;
      this.getdatefrom_inv_h.customer_name = res_hresult.data[0].customer_name;
      this.getdatefrom_inv_h.po_no = res_hresult.data[0].po_no;
      this.getdatefrom_inv_h.attention = res_hresult.data[0].attention;
      this.getdatefrom_inv_h.customer_address =
        res_hresult.data[0].customer_address;
      this.getdatefrom_inv_h.customer_taxid =
        res_hresult.data[0].customer_taxid;
      this.getdatefrom_inv_h.customer_branch =
        res_hresult.data[0].customer_branch;
      this.getdatefrom_inv_h.customer_paymentterm =
        res_hresult.data[0].customer_paymentterm;
      this.getdatefrom_inv_h.customer_vat = res_hresult.data[0].customer_vat;
      this.getdatefrom_inv_h.vat_type = res_hresult.data[0].vat_type;
      if (res_docref_so.data[0]) {
        this.getdatefrom_inv_h.saleorder_id =
          res_docref_so.data[0].saleorder_id;
        this.getdatefrom_inv_h.currency = res_docref_so.data[0].currency;
      }

      this.inv_subtotal = res_hresult.data[0].sub_total;
      this.wth_rate = res_hresult.data[0].wth_rate;
      this.tax_rate = res_hresult.data[0].tax_rate;
      this.amount_total = res_hresult.data[0].amount_total;
      this.amount_total = tolocalestringnumber(this.amount_total);
      this.so_total = res_hresult.data[0].so_total;
      this.so_total = tolocalestringnumber(this.so_total);
      this.ts_total = res_hresult.data[0].ts_total;
      this.ts_total = tolocalestringnumber(this.ts_total);
      this.ad_total = res_hresult.data[0].ad_total;
      this.ad_total = tolocalestringnumber(this.ad_total);
      this.mis_total = res_hresult.data[0].mis_total;
      this.mis_total = tolocalestringnumber(this.mis_total);

      const res_misresult = await api.getdataByIdInv_Mis(this.$route.params.id);
      this.datainv_mis = res_misresult.data;

      this.caltotalAll();
      this.calwth_rate();
      this.caltax_rate();

      const res_soresult = await api.getdataByIdInv_SO(this.$route.params.id);
      this.getdatefrom_inv_so = res_soresult.data;

      const res_tsid = await api.getTs_hListId(this.$route.params.id);
      const dataAllTsId = res_tsid.data;

      let indexAD = 0;
      let indexTS = 0;
      if (dataAllTsId.length > 0) {
        for (let i = 0; i < dataAllTsId.length; i++) {
          if (dataAllTsId[i].ref_type == "TS") {
            this.ts_id[indexTS] = dataAllTsId[i].ref_id;
            indexTS += 1;
          } else if (dataAllTsId[i].ref_type == "AD") {
            this.ad_id[indexAD] = dataAllTsId[i].ref_id;
            indexAD += 1;
          }
        }
      }
      this.ts_idTab = this.ts_id;
      this.ad_idTab = this.ad_id;
      this.ad_inv_id = this.ad_id;
      if (this.getdatafrominv_h == true) {
        this.getdataByCusStatus = "INV";
      }
      this.callsoopentab = true;
      this.$hideLoader();
    },
    async saveinvDraftandSubmit(mode) {
      this.$showLoader()
      if (mode == "Submit") {
        if (this.$route.params.mode == "invoice") {
          const resCheckDoc = await api.checkDocRunning(
            "Invoice",
            localStorage.getItem(server.COMPANYID)
          );
          if (resCheckDoc.status == 200) {
            if (!resCheckDoc.data[0].resCheckDoc) {
              this.$hideLoader();
              this.$store.state.global_dialog = true;
              this.setupAlertDialog(
                true,
                "Information Saved",
                "Please kindly check the value of document running.",
                "text-h5 red--text text-center"
              );
              return;
            }
          } else {
            this.$hideLoader();
            this.$store.state.global_dialog = true;
            this.setupAlertDialog(
              true,
              "Information Saved",
              "ไม่สามารถบันทึกได้",
              "text-h5 red--text text-center"
            );
            return;
          }
        } else if (this.$route.params.mode == "performa") {
          const resCheckDoc = await api.checkDocRunning(
            "PInvoice",
            localStorage.getItem(server.COMPANYID)
          );
          if (resCheckDoc.status == 200) {
            if (!resCheckDoc.data[0].resCheckDoc) {
              this.$hideLoader();
              this.$store.state.global_dialog = true;
              this.setupAlertDialog(
                true,
                "Information Saved",
                "Please kindly check the value of document running.",
                "text-h5 red--text text-center"
              );
              return;
            }
          } else {
            this.$hideLoader();
            this.$store.state.global_dialog = true;
            this.setupAlertDialog(
              true,
              "Information Saved",
              "ไม่สามารถบันทึกได้",
              "text-h5 red--text text-center"
            );
            return;
          }
        }

      }

      let formData = new FormData();

      formData.append("company_inv", this.add_h.company_inv);

      formData.append("company_id", this.add_h.company_id);

      formData.append("dept", this.add_h.dept);

      formData.append("dept_type", this.add_h.dept_type);

      formData.append("inv_type", this.add_h.inv_type);

      formData.append("vat_type", this.add_h.vat_type);

      formData.append("user_create", this.add_h.user_create);

      formData.append("customerid", this.add_h.customerid);
      // this.add_h.customerid = customer_id;

      formData.append("customer_address", this.add_h.customer_address);
      //   this.add_h.customer_address = invoice_address;

      formData.append("customer_taxid", this.add_h.customer_taxid);
      //   this.add_h.customer_taxid = tax_id;

      formData.append("customer_branch", this.add_h.customer_branch);
      //   this.add_h.customer_branch = branch;

      this.image_list.forEach((x, index) => {
        formData.append(`file`, x);
      });

      formData.append("customer_paymentterm", this.payment_term_cus);
      this.add_h.customer_paymentterm = this.payment_term_cus;

      formData.append("customer_vat", this.vat_cus);
      this.add_h.customer_vat = this.vat_cus;

      formData.append("po_no", this.po_no_cus);
      this.add_h.po_no = this.po_no_cus;

      formData.append("attention", this.attention_cus);
      this.add_h.attention = this.attention_cus;

      formData.append("contact_position", this.contact_position_cus);
      this.add_h.contact_position = this.contact_position_cus;

      formData.append("inv_date", this.date);
      this.add_h.inv_date = this.date;

      formData.append("period_cover", this.period_cover);
      this.add_h.period_cover = this.period_cover;

      formData.append(
        "so_total",
        parseFloat(stringcommatonumber(this.so_total.toString()))
      );
      this.add_h.so_total = parseFloat(
        stringcommatonumber(this.so_total.toString())
      );

      formData.append(
        "ts_total",
        parseFloat(stringcommatonumber(this.ts_total.toString()))
      );
      this.add_h.ts_total = parseFloat(
        stringcommatonumber(this.ts_total.toString())
      );

      formData.append(
        "ad_total",
        parseFloat(stringcommatonumber(this.ad_total.toString()))
      );
      this.add_h.ad_total = parseFloat(
        stringcommatonumber(this.ad_total.toString())
      );

      formData.append(
        "mis_total",
        parseFloat(stringcommatonumber(this.mis_total.toString()))
      );
      this.add_h.mis_total = parseFloat(
        stringcommatonumber(this.mis_total.toString())
      );

      formData.append(
        "sub_total",
        parseFloat(stringcommatonumber(this.inv_subtotal.toString()))
      );
      this.add_h.sub_total = parseFloat(
        stringcommatonumber(this.inv_subtotal.toString())
      );

      formData.append("wth_rate", parseFloat(this.wth_rate));
      this.add_h.wth_rate = parseFloat(this.wth_rate);

      formData.append("tax_rate", parseFloat(this.tax_rate));
      this.add_h.tax_rate = parseFloat(this.tax_rate);

      formData.append(
        "amount_total",
        parseFloat(stringcommatonumber(this.amount_total.toString()))
      );
      this.add_h.amount_total = parseFloat(
        stringcommatonumber(this.amount_total.toString())
      );

      // this.add_h.status = 1;

      var add_hresult = [];

      // this.$showLoader();

      if (mode == "Draft") {
        formData.append("status", 1);
        this.add_h.status = 1;
        add_hresult = await api.billing_expense_addInvoice_H(formData);
      } else if (mode == "Submit") {
        formData.append("status", 2);
        this.add_h.status = 2;
        add_hresult = await api.billing_expense_addInvoice_H_Geninv_id(formData);
      } else {
        return;
      }

      if (add_hresult.status == 200 || add_hresult.status == 201) {
        //add inv_so
        this.desserts.forEach(async (x, index) => {
          this.addinv_so.inv_hid = add_hresult.data.id;
          this.addinv_so.so_seq = index + 1;
          this.addinv_so.item_name = x.description;
          this.addinv_so.item_qty = Number(stringcommatonumber(x.unit));
          this.addinv_so.item_price = Number(
            stringcommatonumber(x.PricePerUnit)
          );
          this.addinv_so.item_line_amt = Number(stringcommatonumber(x.amount));
          await api.billing_expense_addInv_SO(this.addinv_so);
        });

        //add inv ts
        if (this.inv_ts_list.length > 0) {
          for (let i = 0; i < this.inv_ts_list.length; i++) {
            let addDataInvTS = {};
            addDataInvTS.inv_hid = add_hresult.data.id;
            addDataInvTS.user_id = this.inv_ts_list[i].emp_id;
            addDataInvTS.emp_rate = Number(this.inv_ts_list[i].tc_rate);
            addDataInvTS.tc_actualchargehour = Number(
              this.inv_ts_list[i].tc_actualchargehour_show
            );
            addDataInvTS.tc_ratechargehour_bath = Number(
              this.inv_ts_list[i].tc_rateChargeHour_bath
            );
            let req_addInvTS = await api.billing_expense_addInvTS(addDataInvTS);
            if (req_addInvTS.status == 200 || req_addInvTS.status == 201) {
              //add sucess
            } else {
              await api.billing_expense_deleteInvTS(add_hresult.data.id);
              break;
            }
          }
        }
        //add inv_docref ts
        if (this.ts_id.length > 0) {
          for (let i = 0; i < this.ts_id.length; i++) {
            this.addinv_docref_ts.inv_hid = add_hresult.data.id;
            this.addinv_docref_ts.ref_id = this.ts_id[i];
            const res_docts = await api.billing_expense_addInv_Docref(this.addinv_docref_ts);
            if (res_docts.status == 200 || res_docts.status == 201) {
              //add sucess
            }
          }
        }

        //add doc_ref ad
        if (this.ad_id.length > 0) {
          for (let i = 0; i < this.ad_id.length; i++) {
            this.addinv_docref_ad.inv_hid = add_hresult.data.id;
            this.addinv_docref_ad.ref_id = this.ad_id[i];
            await api.billing_expense_addInv_Docref(this.addinv_docref_ad);
            //stam status Advance_H = 10 Invioce
            await api.billing_expense_updateAdvanceH(this.ad_id[i], { status: 10 });
          }
        }

        //add invoice miscellanuen
        this.datainv_mis.forEach(async (item, index) => {
          item.inv_hid = add_hresult.data.id;
          item.mis_seq = index + 1;
          await api.billing_expense_addInv_Mis(item);
        });

        // if (this.$route.params.menurequest == "Docket") {
        //   for (const [index, item] of this.docketIdList.entries()) {
        //     await api.updateAppointmentTM(Number(item), { closed: 4 });
        //     var dataadd = {
        //       appointment_id: Number(item),
        //       inv_h_id: Number(add_hresult.data.id),
        //       user_create: Number(this.add_h.user_create),
        //     };
        //     await api.CreateIP_INV(dataadd);
        //   }
        // }
        if (this.$route.params.menurequest == "Docket") {
          for (const [index, item] of this.docketIdList.entries()) {
            await api.updateAppointmentTM(Number(item), { closed: 4 });
            var data_payment_invioce_add = {
              inv_id: Number(add_hresult.data.id),
              module_name: "Docket",
              module_id: Number(item),
              company_id: Number(localStorage.getItem(server.COMPANYID)),
              user_create: Number(localStorage.getItem(server.USER_ID)),
              user_update: Number(localStorage.getItem(server.USER_ID)),
              department_id: Number(localStorage.getItem(server.DEPARTMENT_ID))
            }
            await api.billing_expense_create_payment_invoice(data_payment_invioce_add)
          }
        }

        //payment for inv
        if (this.$route.params.menurequest == "Litigations") {
          try {
            const resQuotations = await api.billing_expense_getAllQuotationsByID(Number(this.$route.query.quotation_id));
            if (resQuotations.data.status == "InProgress") {
              var dataupdateStatus = {
                status: "Invoiced"
              }
              await api.dispute_resolution_update_qutations(Number(this.$route.query.quotation_id), dataupdateStatus)
            }
          } catch (error) {
            console.log("loadQuotations Error")
          }

          var data_payment_invioce_add = {
            inv_id: Number(add_hresult.data.id),
            module_name: "Litigations",
            module_id: this.module_id,
            company_id: Number(localStorage.getItem(server.COMPANYID)),
            user_create: Number(localStorage.getItem(server.USER_ID)),
            user_update: Number(localStorage.getItem(server.USER_ID)),
            department_id: Number(localStorage.getItem(server.DEPARTMENT_ID)),
            quotation_id: Number(this.$route.query.quotation_id)
          }
          await api.billing_expense_create_payment_invoice(data_payment_invioce_add)

        }
        //payment for inv
        if (this.$route.params.menurequest == "Incorporation") {
          try {
            const resQuotations = await api.billing_expense_getAllQuotationsByID(Number(this.$route.query.quotation_id));
            if (resQuotations.data.status == "InProgress") {
              var dataupdateStatus = {
                status: "Invoiced"
              }
              await api.updateQuotationsCore(Number(this.$route.query.quotation_id), dataupdateStatus)
            }
          } catch (error) {
            console.log("loadQuotations Error")
          }

          var data_payment_invioce_add = {
            inv_id: Number(add_hresult.data.id),
            module_name: "Incorporation",
            module_id: this.module_id,
            company_id: Number(localStorage.getItem(server.COMPANYID)),
            user_create: Number(localStorage.getItem(server.USER_ID)),
            user_update: Number(localStorage.getItem(server.USER_ID)),
            department_id: Number(localStorage.getItem(server.DEPARTMENT_ID)),
            quotation_id: Number(this.$route.query.quotation_id)
          }
          await api.billing_expense_create_payment_invoice(data_payment_invioce_add)

        }
        if (this.$route.params.menurequest == "Immigration") {
          try {
            const resQuotations = await api.billing_expense_getAllQuotationsByID(Number(this.$route.query.quotation_id));
            if (resQuotations.data.status == "InProgress") {
              var dataupdateStatus = {
                status: "Invoiced"
              }
              await api.updateQuotationsCore(Number(this.$route.query.quotation_id), dataupdateStatus)
            }
          } catch (error) {
            console.log("loadQuotations Error")
          }

          for (const item of this.moduleIdList) {
            var data_payment_invioce_add = {
              inv_id: Number(add_hresult.data.id),
              module_name: "Immigration",
              module_id: Number(item),
              company_id: Number(localStorage.getItem(server.COMPANYID)),
              user_create: Number(localStorage.getItem(server.USER_ID)),
              user_update: Number(localStorage.getItem(server.USER_ID)),
              department_id: Number(localStorage.getItem(server.DEPARTMENT_ID)),
              quotation_id: Number(this.$route.query.quotation_id)
            }
            await api.billing_expense_create_payment_invoice(data_payment_invioce_add)
          }

        }

        // await api.updateByIDtransaction(Number(this.$route.query.im_id), {status: 'Payment Request'})
        // const imIds = this.$route.query.im_id
        //   ? this.$route.query.im_id.split(",").map((id) => id.trim())
        //   : [];

        // if (imIds.length > 0) {
        //   for (const [index, item] of imIds.entries()) {
        //     await api.updateByIDtransaction(Number(item), {
        //       status: "Payment Request",
        //     });

        //     var dataaddIM_inv = {
        //       im_trans_id: Number(item),
        //       inv_h_id: add_hresult.data.id,
        //       user_create: Number(localStorage.getItem(server.USER_ID)),
        //     };

        //     await api.CreateIM_INV(dataaddIM_inv);
        //   }
        // }



        this.$hideLoader();

        //load succes
        this.$store.state.global_push_dialog = true;
        this.setupAlertDialogPush(
          true,
          "Information Saved",
          "Information successfully saved",
          "text-h5 green--text text-center",
          `/edit-invoice/${add_hresult.data.id}/inv_h/edit`
        );
      } else {
        this.$hideLoader();
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Information Saved",
          "ไม่สามารถบันทึกได้",
          "text-h5 red--text text-center"
        );
      }
    },

    async getdatafromSOcomponent(
      customer_id,
      invoice_address,
      tax_id,
      branch,
      payment_term,
      vat,
      vat_type,
      testsumso,
      so_hid
    ) {
      if (this.getdatafrominv_h === false) {
        if (!payment_term) {
          payment_term = 0;
        }
        this.so_total = testsumso;
        this.so_total = tolocalestringnumber(this.so_total);
        this.tax_rate = vat;
        this.add_h.customerid = customer_id;
        this.add_h.customer_address = invoice_address;
        this.add_h.customer_taxid = tax_id;
        this.add_h.customer_branch = branch;
        this.add_h.customer_paymentterm = payment_term;
        this.add_h.customer_vat = vat;
        this.add_h.vat_type = vat_type;
        this.invoice_address = invoice_address;
        this.addinv_docref_so.ref_id = so_hid;
      }

      this.caltotalAll();
      this.calwth_rate();
      this.caltax_rate();
    },
    async getdatafromSOtable(dataintable) {
      this.desserts = dataintable;
    },
    async getdatavatcus(VAT_CUS) {
      this.vat_cus = VAT_CUS;
    },
    async getdatapaymentcus(payment_CUS) {
      this.payment_term_cus = payment_CUS;
    },
    async getdataPonoCus(PONO_CUS) {
      this.po_no_cus = PONO_CUS;
    },
    async getdataAttentionCus(attention) {
      this.attention_cus = attention;
    },
    async getdatacontact_positionCus(contact_position) {
      this.contact_position_cus = contact_position;
    },
    async getdatavat_type(vat_type) {
      this.vat_type_cus = vat_type;
      this.add_h.vat_type = vat_type;
      this.calgrandtotal();
    },

    async getdatafromTStotal(TStotal) {
      this.ts_total = TStotal;
      this.ts_total = tolocalestringnumber(this.ts_total);
      this.caltotalAll();
      this.calwth_rate();
      this.caltax_rate();
    },
    async getdatafromAdtotal(Adtotal) {
      this.ad_total = Adtotal;
      this.ad_total = tolocalestringnumber(this.ad_total);
      this.caltotalAll();
      this.calwth_rate();
      this.caltax_rate();
    },
    async getTsId(TS_ID) {
      this.ts_id = TS_ID;
    },
    async getAdId(AS_ID) {
      this.ad_id = AS_ID;
    },
    async getAdInvioceId(AD_Invioce_Id) {
      this.ad_inv_id = AD_Invioce_Id;
    },
    async getSelected_showE(Selected_ShowE) {
      this.selected_showE = Selected_ShowE;
    },
    async getOper_sel(Oper_Sel) {
      this.oper_sel = Oper_Sel;
    },
    async getInvTsList(invTs_List) {
      this.inv_ts_list = invTs_List;
    },
    async getSelected_showEAv(Selected_ShowAv) {
      this.selected_showAv = Selected_ShowAv;
    },
    async getOper_selAv(Oper_SelAv) {
      this.oper_sel_Av = Oper_SelAv;
    },
    async getdatafromSOisheader(testsumso) {
      this.so_total = testsumso;
      this.caltotalAll();
      this.calwth_rate();
      this.caltax_rate();
    },
    async getdatafromSOvat(VAT) {
      this.tax_rate = VAT;
      this.caltotalAll();
      this.calwth_rate();
      this.caltax_rate();
    },
    async getdatafromSOCustomer(Customer) {
      this.Cus_Data = Customer;

      this.cus_code = this.Cus_Data.cust_account;
      this.cusid_freetext_ts = this.Cus_Data.id;
      this.add_h.customerid = this.Cus_Data.id;
      this.add_h.customer_address = `${this.Cus_Data.address_invoice} ${this.Cus_Data.province_invoice} ${this.Cus_Data.zipcode_invoice}`;
      this.add_h.customer_taxid = this.Cus_Data.taxid;
      this.add_h.customer_branch = this.Cus_Data.branch;
      this.add_h.customer_paymentterm = this.Cus_Data.payment_term;
      this.add_h.customer_vat = this.Cus_Data.vat;
      this.add_h.vat_type = this.Cus_Data.vat_type;
    },

    async getdatafromMis(data) {
      this.mis_total = 0;
      this.datainv_mis = [];
      this.datainv_mis = data;
      this.datainv_mis.forEach((x, index) => {
        this.mis_total += parseFloat(x.amount);
      });
      this.mis_total = tolocalestringnumber(this.mis_total);
      this.caltotalAll();
      this.calwth_rate();
      this.caltax_rate();
    },

    async getdatafromadditional(data) {
      this.add_h.additional_top = data.additional_top;
      this.add_h.additional_bottom = data.additional_bottom;
    },

    caltotalAll() {
      // this.inv_subtotal =
      //   parseFloat(stringcommatonumber(this.so_total.toString())) +
      //   parseFloat(stringcommatonumber(this.ts_total.toString())) +
      //   parseFloat(stringcommatonumber(this.ad_total.toString())) +
      //   parseFloat(stringcommatonumber(this.mis_total.toString()));
      // this.inv_subtotal = tolocalestringnumber(this.inv_subtotal);
      this.calgrandtotal();
    },
    tabClicked(selectedTab) { },
    tabChanged(selectedTab) { },
    closeDelete() { },
    deleteItemConfirm() { },
    calwth_rate() {
      // this.wth_ratetotal = parseFloat(
      //   (parseFloat(stringcommatonumber(this.inv_subtotal.toString())) *
      //     parseFloat(stringcommatonumber(this.wth_rate.toString()))) /
      //     100
      // );
      // this.wth_ratetotal = tolocalestringnumber(this.wth_ratetotal);
      this.calgrandtotal();
    },
    caltax_rate() {
      // this.tax_ratetotal = parseFloat(
      //   (parseFloat(stringcommatonumber(this.inv_subtotal.toString())) *
      //     parseFloat(stringcommatonumber(this.tax_rate.toString()))) /
      //     100
      // );
      // this.tax_ratetotal = tolocalestringnumber(this.tax_ratetotal);
      this.calgrandtotal();
    },

    calgrandtotal() {
      this.inv_subtotal =
        parseFloat(stringcommatonumber(this.so_total.toString())) +
        parseFloat(stringcommatonumber(this.ts_total.toString())) +
        parseFloat(stringcommatonumber(this.ad_total.toString())) +
        parseFloat(stringcommatonumber(this.mis_total.toString()));
      this.inv_subtotal = tolocalestringnumber(this.inv_subtotal);

      if (this.add_h.vat_type == "E") {
        this.tax_ratetotal = parseFloat(
          (parseFloat(stringcommatonumber(this.inv_subtotal.toString())) *
            parseFloat(stringcommatonumber(this.tax_rate.toString()))) /
          100
        );
        this.tax_ratetotal = tolocalestringnumber(this.tax_ratetotal);
        this.wth_ratetotal = parseFloat(
          (parseFloat(stringcommatonumber(this.inv_subtotal.toString())) *
            parseFloat(stringcommatonumber(this.wth_rate.toString()))) /
          100
        );
        this.wth_ratetotal = tolocalestringnumber(this.wth_ratetotal);

        this.amount_total = parseFloat(
          parseFloat(stringcommatonumber(this.inv_subtotal.toString())) -
          parseFloat(stringcommatonumber(this.wth_ratetotal.toString())) +
          parseFloat(stringcommatonumber(this.tax_ratetotal.toString()))
        ).toFixed(2);
        this.amount_total = tolocalestringnumber(this.amount_total);
      } else if (this.add_h.vat_type == "I") {
        this.amount_total =
          stringcommatonumber(this.inv_subtotal) / (1 + this.wth_rate / 100);
        this.wth_ratetotal = (
          stringcommatonumber(this.inv_subtotal) - this.amount_total
        ).toFixed(2);
        this.inv_subtotal = (
          this.amount_total /
          (1 + this.tax_rate / 100)
        ).toFixed(2);
        this.tax_ratetotal = (this.amount_total - this.inv_subtotal).toFixed(2);

        this.amount_total = tolocalestringnumber(this.amount_total);
        this.inv_subtotal = tolocalestringnumber(this.inv_subtotal);
        this.tax_ratetotal = tolocalestringnumber(this.tax_ratetotal);
        this.wth_ratetotal = tolocalestringnumber(this.wth_ratetotal);
      } else {
      }
    },
    async deleteItemConfirmForm() {
      this.$router.push(`/invoice`);
    },
    async closeDeleteForm() {
      this.dialogDeleteForm = false;
    },
    setupAlertDialog(status, title, message, text_color, link) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
    },
    setupAlertDialogPush(status, title, message, text_color, link) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
      this.link = link;
    },
    //---------------function file------------//
    async popupdeletefile(index) {
      this.fileindex = index;
      this.dialogDelete = true;
    },

    async closeDelete() {
      this.fileindex = -1;
      this.dialogDelete = false;
    },
    async deleteItemConfirm() {
      this.preview_list2 = [];
      this.getpreview_list.splice(this.fileindex, 1);
      this.image_list.splice(this.fileindex, 1);
      await this.getPdfforAdd(this.getpreview_list);

      this.filename.splice(this.fileindex, 1);
      this.preview_list2 = this.preview_list;
      this.fileindex = -1;
      this.dialogDelete = false;
    },
    async popupdeleteimage() {
      this.dialogDeleteimage = true;
    },
    async closeDeleteimage() {
      this.dialogDeleteimage = false;
    },
    async deleteItemConfirmimage() {
      this.checkimageadd = false;
      this.image = null;
      this.previewimage = "";
      this.imagename = "";
      this.dialogDeleteimage = false;
    },
    async previewnoticefilepdf(file_name) {
      this.previewpopupfile2 = [];

      let file_name_s = file_name;
      let pdf_newTab = window.open(
        `${POAUrl}/${this.$route.params.id}/${file_name_s}`
      );

      return;
    },
    async popuppreviewfile(fileindex) {
      const file = this.image_list[fileindex];
      if (!file) return;

      // เช็คว่าเป็น PDF จริง
      if (file.type !== "application/pdf") {
        alert("ไฟล์นี้ไม่ใช่ PDF");
        return;
      }

      const fileUrl = URL.createObjectURL(file);

      // เปิดใหม่แบบปกติเลย (ไม่ต้อง document.write)
      window.open(fileUrl, "_blank");
    },
    async closepreviewfile() {
      this.dialogpreviewfile = false;
    },
    async popuppreviewimage() {
      this.dialogpreviewimage = true;
    },
    async closepreviewimage() {
      this.dialogpreviewimage = false;
    },
    previewImage: function (event) {
      var input = event.target;
      if (input.files) {
        var reader = new FileReader();
        reader.onload = (e) => {
          this.previewimage = e.target.result;
          this.checkimageadd = true;
        };
        this.image = input.files[0];
        reader.readAsDataURL(input.files[0]);
      }

      this.imagename = this.image.name;
    },
    async previewMultiImage(event) {
      this.filename = [];
      this.preview_list = [];
      this.getpreview_list = [];
      // this.image_list = [];
      var input = event.target;
      var count = input.files.length;
      var index = 0;

      if (input.files) {
        while (count--) {
          var reader = new FileReader();
          reader.onload = (e) => {
            this.getpreview_list.push(e.target.result);
            this.preview_list.push(e.target.result);
          };
          if (input.files[index].type === "application/pdf") {
            this.image_list.push(input.files[index]);
            reader.readAsDataURL(input.files[index]);
          }
          index++;
        }
      }

      await this.getPdfforAdd(this.getpreview_list);

      this.preview_list2 = this.preview_list;

      this.image_list.forEach((x, index) => {
        this.filename.push(x.name);

        if (index == this.image_list.length - 1) {
        }
      });

      this.checkfileeadd = true;
    },

    reset: function () {
      this.image = null;
      this.previewimage = null;
      this.image_list = [];
      this.preview_list = [];
    },
    async getPdfforpreview(datafile) {
      this.previewpopupfile = [];
      let getfile = [];
      getfile = datafile;
      this.previewpopupfile.push(pdfvuer.createLoadingTask(`${getfile}`));
      this.previewpopupfile.forEach((item, index) => {
        item.then((pdf) => {
          this.numPagespreview = pdf.numPages;
        });
      });
    },

    async getPdfforAdd(item) {
      this.preview_list = [];
      let getfile = [];
      getfile = item;
      getfile.forEach((file, index) => {
        this.preview_list.push(pdfvuer.createLoadingTask(`${file}`));
      });
      this.preview_list.forEach((item, index) => {
        item.then((pdf) => {
          this.numPages = pdf.numPages;
          // window.onscroll = function() {
          //   changePage();
          //   stickyNav();
          // };
          // Get the offset position of the navbar
          // var sticky = $("#buttons")[0].offsetTop;
          // // Add the sticky class to the this.$refs.nav when you reach its scroll position. Remove "sticky" when you leave the scroll position
          // function stickyNav() {
          //   if (window.pageYOffset >= sticky) {
          //     $("#buttons")[0].classList.remove("hidden");
          //   } else {
          //     $("#buttons")[0].classList.add("hidden");
          //   }
          // }
          function changePage() {
            var i = 1,
              count = Number(pdf.numPages);
            do {
              if (
                window.pageYOffset >=
                this.findPos(document.getElementById(i)) &&
                window.pageYOffset <=
                this.findPos(document.getElementById(i + 1))
              ) {
                this.page = i;
              }
              i++;
            } while (i < count);
            if (
              window.pageYOffset >= this.findPos(document.getElementById(i))
            ) {
              this.page = i;
            }
          }
        });
      });
      this.checkfileadd = true;
    },
    handle_pdf_link: function (params) {
      // Scroll to the appropriate place on our page - the Y component of
      // params.destArray * (div height / ???), from the bottom of the page div
      var page = document.getElementById(String(params.pageNumber));
      page.scrollIntoView();
    },
    findPos(obj) {
      return obj.offsetTop;
    },
    //--------------------end funcfile--------------------//
  },
  beforeCreate() {
    this.$store.state.navMenu = true;
  },
};
</script>

<style scoped>
body {
  background: rgb(204, 204, 204);
}

.page {
  background: white;
  display: block;
  margin: 0 auto;
  margin-bottom: 0.5cm;
  /* box-shadow: 0 0 0.5cm rgba(0, 0, 0, 0.5); */
}

.page[size="A4"] {
  width: 21cm;
  height: 29.7cm;
}

.page[size="A4"][layout="landscape"] {
  width: 29.7cm;
  height: 21cm;
}

.page[size="A3"] {
  width: 29.7cm;
  height: 42cm;
}

.page[size="A3"][layout="landscape"] {
  width: 42cm;
  height: 29.7cm;
}

.page[size="A5"] {
  width: 14.8cm;
  height: 21cm;
}

.page[size="A5"][layout="landscape"] {
  width: 21cm;
  height: 14.8cm;
}

@page {
  size: 7in 9.25in;
  margin: 27mm 16mm 27mm 16mm;
}

page {
  position: relative;
  background: white;
  display: block;
  margin: 0 auto;
  line-height: 1.5;
  /* margin-bottom: 0.5cm; */
  border: 1px solid;
  /* box-shadow: 0 0 0.5cm rgba(0, 0, 0, 0.5); */
  font-family: "Roboto", sans-serif;
}

page[size="A4"] {
  width: 21cm;
  height: 29.7cm;
}

page[size="A4"][layout="portrait"] {
  width: 29.7cm;
  height: 21cm;
}

@media print {

  body,
  page {
    margin: 0;
    box-shadow: 0;
  }

  html,
  body {
    width: 210mm;
    height: 297mm;
  }
}

.page {
  display: inline-block;
  position: relative;
  height: 297mm;
  width: 210mm;
  font-size: 12pt;
  margin: 2em auto;
  padding: calc(var(--bleeding) + var(--margin));
  /* box-shadow: 0 0 0.5cm rgba(0, 0, 0, 0.5); */
  background: white;
}

@media screen {
  .page::after {
    position: absolute;
    content: "";
    top: 0;
    left: 0;
    width: calc(100% - var(--bleeding) * 2);
    height: calc(100% - var(--bleeding) * 2);
    margin: var(--bleeding);
    /* outline: thin dashed black; */
    pointer-events: none;
    z-index: 9999;
  }
}

.v-btn:not(.v-btn--round).v-size--default.buttonblue {
  background-color: #1d2442;
  color: white;
}

.btnuploadfile {
  border: 2px solid;
}

.v-btn:not(.v-btn--round).v-size--default.buttonred100 {
  width: 100%;
  background-color: #9e3b1b;
  color: white;
}

.v-btn:not(.v-btn--round).v-size--default.buttonwhite {
  width: 100%;
  background-color: #f5f5f5;
  color: black;
}

h3 {
  font-size: 1.17em;
}

h4 {
  font-size: 1em;
}

.test {
  border-style: double;
}

.borderblack {
  border-style: solid;
  border-width: thin;
}

.mt-50 {
  margin-top: 50px;
}

.mb-50 {
  margin-bottom: 50px;
}

.btn-light {
  color: #333;
  background-color: #fafafa;
  border-color: #ddd;
}

@media (min-width: 768px) {
  .wmin-md-400 {
    min-width: 400px !important;
  }
}

.btn-primary {
  color: #fff;
  background-color: #2196f3;
}

.btn-labeled>b {
  position: absolute;
  top: -1px;
  background-color: blue;
  display: block;
  line-height: 1;
  padding: 0.62503rem;
}

.alignleft {
  float: left;
}

.alignright {
  float: right;
}

.aligncenter {
  text-align: center;
}

.captionreport {
  font-size: 0.85rem;
  font-weight: 400;
  letter-spacing: 0.0333333333em;
  line-height: 1.25rem;
  font-family: "Roboto", sans-serif;
}

.caption {
  font-size: 0.75rem;
  font-weight: 400;
  letter-spacing: 0.0333333333em;
  line-height: 1.25rem;
  font-family: "Roboto", sans-serif;
}

.captionhtable {
  font-size: 1rem;
  font-weight: 400;
  letter-spacing: 0.0333333333em;
  line-height: 1.25rem;
  font-family: "Roboto", sans-serif;
}

.rowprpo {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-box-flex: 1;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  margin-right: -12px;
  margin-left: -12px;
}

.colprpo {
  -ms-flex-preferred-size: 0;
  flex-basis: 0;
  -webkit-box-flex: 1;
  -ms-flex-positive: 1;
  flex-grow: 1;
  max-width: 100%;
}

.col-md-1report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 8.333333333333333%;
  flex: 0 0 8.333333333333333%;
  max-width: 8.333333333333333%;
}

.col-md-2report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 16.66666666666667%;
  flex: 0 0 16.66666666666667%;
  max-width: 16.66666666666667%;
}

.col-md-3report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 25%;
  flex: 0 0 25%;
  max-width: 25%;
}

.col-md-4report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 33.33333333333333%;
  flex: 0 0 33.33333333333333%;
  max-width: 33.33333333333333%;
}

.col-md-5report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 41.66666666666667%;
  flex: 0 0 41.66666666666667%;
  max-width: 41.66666666666667%;
}

.col-md-6report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 50%;
  flex: 0 0 50%;
  max-width: 50%;
}

.col-md-7report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 58.33333333333333%;
  flex: 0 0 58.33333333333333%;
  max-width: 58.33333333333333%;
}

.col-md-8report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 66.66666666666667%;
  flex: 0 0 66.66666666666667%;
  max-width: 66.66666666666667%;
}

.col-md-9report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 75%;
  flex: 0 0 75%;
  max-width: 75%;
}

.col-md-10report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 83.33333333333333%;
  flex: 0 0 83.33333333333333%;
  max-width: 83.33333333333333%;
}

.col-md-11report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 91.66666666666667%;
  flex: 0 0 91.66666666666667%;
  max-width: 91.66666666666667%;
}

.col-md-12report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 100%;
  flex: 0 0 100%;
  max-width: 100%;
}

.mt-5prpo {
  margin-top: -5px !important;
}

.mt-30prpo {
  margin-top: -30px !important;
}

.mt30 {
  margin-top: 30px !important;
}

.mt20 {
  margin-top: 20px !important;
}

.mt10 {
  margin-top: 10px !important;
}

.mt25 {
  margin-top: 25px !important;
}

.mt-25prpo {
  margin-top: -25px !important;
}

.mr30prpo {
  margin-right: 30px !important;
}

.ml30prpo {
  margin-left: 30px !important;
}

.ml2prpo {
  margin-left: 2px !important;
}

.ml10prpo {
  margin-left: 10px !important;
}

.ml-40prpo {
  margin-left: -40px !important;
}

.borderblockpr {
  border: 1px solid black;
  width: 300px;
  height: 80px;
  /* background: white; */
  /* box-sizing: border-box; */
  display: inline-block;
}

.col-md-4pr {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 30%;
  flex: 0 0 30%;
  max-width: 30%;
}

.col-md-8pr {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 70%;
  flex: 0 0 70%;
  max-width: 70%;
}

.col-md-4prrd {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 50%;
  flex: 0 0 50%;
  max-width: 50%;
}

.col-md-8prrd {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 50%;
  flex: 0 0 50%;
  max-width: 50%;
}

.textalignleft {
  text-align: left;
}

.textalignright {
  text-align: right;
}

.textaligncenter {
  text-align: center;
}

table {
  table-layout: fixed;
  border-collapse: collapse;
  width: 100%;
  /* border: 1px solid black; */
}

.prbordertop {
  border-top: 1px solid black;
}

.prborderbottom {
  border-bottom: 1px solid black;
}

.prbordertop2pxhtable {
  padding-top: 8px;
  /* border-top: 1px solid black; */
}

.prborderbottom2pxhtable {
  padding-bottom: 8px;
  border-bottom: 1px solid black;
}

td {
  /* border: 1px solid black; */
}

td.tdborder-top {
  border-top: 1px solid black;
}

td.tdborder-right {
  border-right: 1px solid black;
}

td.tdborder-left {
  border-left: 1px solid black;
}

td.tdborder-bottom {
  border-bottom: 1px solid black;
}

th {
  /* border: 1px solid black; */
}

th.thborder-top {
  border-top: 1px solid black;
}

th.thborder-right {
  border-right: 1px solid black;
}

th.thborder-left {
  border-left: 1px solid black;
}

th.thborder-bottom {
  border-bottom: 1px solid black;
}

.width15 {
  word-wrap: break-word;
  width: 15%;
}

.width10 {
  word-wrap: break-word;
  width: 10%;
}

.width20 {
  word-wrap: break-word;
  width: 20%;
}

.width30 {
  word-wrap: break-word;
  width: 30%;
}

.width40 {
  word-wrap: break-word;
  width: 40%;
}

.width50 {
  word-wrap: break-word;
  width: 50%;
}

.width60 {
  word-wrap: break-word;
  width: 60%;
}

.width70 {
  word-wrap: break-word;
  width: 70%;
}

.width75 {
  word-wrap: break-word;
  width: 75%;
}

.width80 {
  word-wrap: break-word;
  width: 80%;
}

.width85 {
  word-wrap: break-word;
  width: 85%;
}

.width90 {
  word-wrap: break-word;
  width: 90%;
}

.width100 {
  word-wrap: break-word;
  width: 100%;
}

@media print {

  /*
            body.A3.landscape { width: 420mm }
            body.A3, body.A4.landscape { width: 297mm }
            body.A4, body.A5.landscape { width: 210mm }
            body.A5 { width: 148mm }*/
  .printonly {
    display: block;
  }

  .noprint {
    display: none;
  }

  .A3.landscape {
    width: 420mm;
  }

  .A3,
  .A4.landscape {
    width: 297mm;
  }

  .A4,
  .A5.landscape {
    width: 210mm;
  }

  .A5 {
    width: 148mm;
  }
}

header {
  top: 0;
  padding-top: 150mm;
  padding-bottom: 3mm;
}

footer {
  bottom: 0;
  color: #000;
  padding-top: 3mm;
  padding-bottom: 5mm;
}

header,
footer {
  /* position: fixed; */
  left: 0;
  right: 0;
  background-color: #ccc;
  padding-right: 1.5cm;
  padding-left: 1.5cm;
}

.footerprpo {
  position: absolute;
  bottom: 10px;
  width: 100%;
}

.borderauto {
  border: 1px solid;
  margin: -1px;
}

.bordersignature {
  height: 110px;
  border: 1px solid;
  margin: -1px;
}

.fixfourrow {
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  height: 80px;
  overflow: hidden;
  text-align: left;
}

.fixthreerow {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  height: 60px;
  overflow: hidden;
  text-align: left;
}

.fixtworow {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  height: 40px;
  overflow: hidden;
  text-align: left;
}

.fixonerow {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  height: 20px;
  overflow: hidden;
  text-align: left;
}

.fixonerowcenter {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  height: 20px;
  overflow: hidden;
  text-align: center;
}

.fontsize10 {
  font-size: 10px;
}

.fontsize12 {
  font-size: 12px;
}

.fontsize13 {
  font-size: 12px;
}

.borderwidththin {
  border-width: thin;
}

.titledatadetailintable {
  font-weight: bold;
  text-decoration: underline;
}

.paddingleftintable {
  padding-left: 10px;
}

.paddingrightintable {
  padding-right: 10px;
}

.v-text-field.v-text-field--enclosed .v-text-field__details .cutdetailtextfield {
  padding-top: 0px;
  margin-bottom: -25px;
}

.v-application a {
  color: white;
}

.containertab {
  max-width: 100%;
  min-width: 100%;
  margin: 40px auto;
  /* font-family: Arial, Helvetica, sans-serif; */
  font-size: 0.9em;
  color: #888;
}

.tabs {
  overflow: hidden;
  /* margin-left: 20px; */
  margin-bottom: -2px;
}

.tabs ul {
  list-style-type: none;
  margin-left: 20px;
}

.tabs a {
  float: left;
  cursor: pointer;
  padding: 10px 24px;
  transition: background-color 0.2s;
  border: 1px solid #595959;
  /* border-right: none; */
  border-right: 1px solid #595959;
  background-color: #595959;
  border-radius: 10px 10px 0 0;
  font-weight: bold;
}

/* .tabs a:last-child {
    border-right: 1px solid #595959;
  } */

/* Change background color of tabs on hover */
.tabs a:hover {
  background-color: #aaa;
  color: #fff;
}

/* Styling for active tab */
.tabs a.active {
  background-color: #fff;
  color: #484848;
  border-bottom: 2px solid #fff;
  cursor: default;
}

/* Style the tab content */
.tabcontent {
  padding: 30px;
  border: 1px solid #595959;
  /* border-radius: 10px; */
  border-radius: 0px 10px 10px 10px;
  box-shadow: 3px 3px 6px #e1e1e1;
}

.btn-width {
  width: 120px;
}

.v-btn:not(.v-btn--round).v-size--default.buttonred {
  background-color: #9e3b1b;
  color: white;
}

.width16 {
  width: 16%;
}

.widthsubtotal {
  width: 18%;
}

.widthsubtotalG {
  width: 36%;
}

.widthplus {
  width: 4%;
}

.widthsub {
  width: 6%;
}

.widthgrandnull {
  width: 102%;
}

.widthspace {
  width: 4%;
}

.widthglessword {
  width: 60%;
}

.widthlesspersen {
  width: 12%;
}

.widthtextpersen {
  width: 8%;
}

.widthlesstotal {
  width: 16%;
}

.doubleunderline {
  /* text-decoration-line: underline;
  text-decoration-style: double; */
  border-bottom: 3px double #000000;
  border-top: 1px double #000000;
  /* text-underline-offset: 4px; */
  /* padding-bottom:4px;
  height: 1px; */
}
</style>
